import React, { useEffect, useState } from 'react';
import H1 from '../Images/Hma.jpeg';
import L1 from '../Images/logo-w.png';
import axios from 'axios';
import { FaAward } from 'react-icons/fa';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';



const AwardNominationData = () => {

    const [currentPage, setCurrentPage] = useState(1);
    const nominationsPerPage = 10;
    const [activeAward, setActiveAward] = useState('');
    const [form1, setForm1] = useState([]);
    const [form2, setForm2] = useState([]);

    const [nominations, setNominations] = useState([]);
    useEffect(() => {
        if (activeAward === 'academician') {
            axios.get('https://rvapi.emedha.in/pages/api/api/academicianexcellenceaward')
                .then(response => {
                    const data = response.data;
                    const safeArray = Array.isArray(data) ? data : [data];
                    setNominations(safeArray);
                    setForm1(safeArray.map(item => item.nominations_form1).filter(entry => entry !== null));
                    setForm2(safeArray.map(item => item.nominations_form2).filter(entry => entry !== null));
                    setCurrentPage(1);
                })
                .catch(error => {
                    console.error("Error fetching nominations:", error);
                });
        }
    }, [activeAward]);

    const handleDownloadAcademicianExcellencePdf = (item, index) => {
        const doc = new jsPDF();
        doc.setFontSize(18);
        doc.setTextColor(33, 37, 41);
        doc.text('Academician Excellence Award Details', 14, 22);
        doc.setFontSize(12);

        const acad = item.academician_excellence_award || {};

        // Data to display in the PDF
        const data = [
            ['Name', acad.name || '-'],
            ['Designation', acad.designation || '-'],
            ['Age', acad.age || '-'],
            ['Research Papers Published Date', acad.research_papers_published_date !== '0000-00-00' ? new Date(acad.research_papers_published_date).toLocaleDateString() : '-'],
            ['Research Papers Published Topic', acad.research_papers_published_paper_topic || '-'],
            ['Research Papers Published Institute', acad.research_papers_published_institute || '-'],
            ['Research Papers Published Recognition', acad.research_papers_published_recognition || '-'],
            ['Research Papers Published Other Info', acad.research_papers_published_other_info || '-'],
            ['Articles Published Date', acad.articles_published_date !== '0000-00-00' ? new Date(acad.articles_published_date).toLocaleDateString() : '-'],
            ['Articles Published Topic', acad.articles_published_topic || '-'],
            ['Articles Published Institute', acad.articles_published_institute || '-'],
            ['Articles Published Recognition', acad.articles_published_recognition || '-'],
            ['Articles Published Other Info', acad.articles_published_other_info || '-'],
            ['Books Published Date', acad.books_published_date !== '0000-00-00' ? new Date(acad.books_published_date).toLocaleDateString() : '-'],
            ['Books Published Topic/Subject', acad.books_published_topic_subject || '-'],
            ['Books Published Recognition', acad.books_published_recognition || '-'],
            ['Books Published Other Info', acad.books_published_other_info || '-'],
            ['National/International Date', acad.national_international_date !== '0000-00-00' ? new Date(acad.national_international_date).toLocaleDateString() : '-'],
            ['National/International Topic', acad.national_international_topic || '-'],
            ['National/International Institute', acad.national_international_institute || '-'],
            ['National/International Recognition', acad.national_international_recognition || '-'],
            ['National/International Other Info', acad.national_international_other_info || '-'],
            ['Experience Teaching College', acad.experience_teaching_college || '-'],
            ['Experience Teaching Period', acad.experience_teaching_period || '-'],
            ['Experience Teaching Years', acad.experience_teaching_years || '-'],
            ['Experience Teaching Designation', acad.experience_teaching_designation || '-'],
            ['Experience Teaching Specialization', acad.experience_teaching_specialization || '-'],
            ['Innovation in Teaching Methodology', acad.innovation_in_teaching_methodology ? 'Yes' : 'No'],
            ['Innovation in Management', acad.innovation_in_management ? 'Yes' : 'No'],
            ['Ability to Handle Courses', acad.ability_to_handle_courses ? 'Yes' : 'No'],
            ['Academy-Industry Relation', acad.academy_industry_relation ? 'Yes' : 'No'],
            ['Research and Innovation Comments', acad.research_innovation_commentbox || '-'],
            ['Qualifies for Award Comments', acad.qualifies_for_award_commentbox || '-'],
            ['Signature Name', acad.signature_name || '-'],
            ['Signature Date', acad.signature_date ? new Date(acad.signature_date).toLocaleDateString() : '-']
        ];

        // Add the table to the PDF
        autoTable(doc, {
            startY: 30,
            head: [['Field', 'Details']],
            body: data,
            styles: { cellPadding: 2, fontSize: 10 },
            headStyles: { fillColor: [0, 123, 255] },
            alternateRowStyles: { fillColor: [240, 240, 240] }
        });

        // If signature image URL is available, embed it in the PDF
        if (acad.signature_image_url) {
            const imageUrl = acad.signature_image_url;
            // Load image as base64 and add to the PDF
            const img = new Image();
            img.src = imageUrl;
            img.onload = function () {
                doc.addImage(img, 'JPEG', 15, doc.lastAutoTable.finalY + 10, 50, 20); // Adjust the size and position of the image
                doc.save(`Academician_Excellence_Award_${index + 1}.pdf`);
            };
        } else {
            doc.save(`Academician_Excellence_Award_${index + 1}.pdf`);
        }
    };



    const [excellenceaward, setExcellenceaward] = useState([]);
    useEffect(() => {
        if (activeAward === 'student') {
            axios.get('https://rvapi.emedha.in/pages/api/api/hma_best_student_chapter_award')
                .then(response => {
                    const data = response.data;
                    const safeArray = Array.isArray(data) ? data : [data];
                    setExcellenceaward(safeArray);
                    setForm1(safeArray.map(item => item.nominations_form1));
                    setForm2(safeArray.map(item => item.nominations_form2));
                    setCurrentPage(1);
                })
                .catch(error => {
                    console.error("Error fetching nominations:", error);
                });
        }
    }, [activeAward]);

    const handleDownloadHmaStudentPdf = (item, index) => {
        const doc = new jsPDF();
        doc.setFontSize(18);
        doc.setTextColor(33, 37, 41);
        doc.text('HMA Best Student Chapter Award Details', 14, 22);
        doc.setFontSize(12);

        const chapter = item.hma_best_student_chapter_award || {};

        const data = [
            ['College Name', chapter.college_name || '-'],
            ['Address', chapter.address || '-'],
            ['Phone', chapter.phone || '-'],
            ['College Email', chapter.college_email || '-'],
            ['University Affiliated', chapter.University_Affiliated || '-'],
            ['Date of Incorporation', chapter.Date_of_Incorporation ? new Date(chapter.Date_of_Incorporation).toLocaleDateString() : '-'],
            ['Strength of the College', chapter.Strength_of_the_College || '-'],
            ['Strength of Teaching Staff', chapter.Strength_of_Teaching_Staff || '-'],
            ['Name of Principal', chapter.Name_Of_Principal || '-'],
            ['Principal Phone', chapter.Principal_Phone || '-'],
            ['Principal Email', chapter.Principal_Email || '-'],
            ['Name of Student', chapter.Name_of_the_Student || '-'],
            ['Date of Incorporation (Student)', chapter.Date_of_Incorporation_Student ? new Date(chapter.Date_of_Incorporation_Student).toLocaleDateString() : '-'],
            ['Names of Management', chapter.Names_of_Management || '-'],
            ['No. of Student Members', chapter.No_of_student_Members || '-'],
            ['Operating Premises in College', chapter.operating_premises_in_the_College || '-'],
            ['Approval of College and HMA', chapter.approval_of_College_and_HMA || '-'],
            ['Mission Statement', chapter.Mission_Statement || '-'],
            ['Faculty Advisor', chapter.Faculty_Advisor || '-'],
            ['Alumni and Interactions', chapter.Alumni_and_interacts || '-'],
            ['Student Fees Details', chapter.Student_fees_details || '-'],
            ['Lecture Sessions (No)', chapter.LECTURE_SESSIONS_no || '-'],
            ['Lecture Sessions (Participants)', chapter.LECTURE_SESSIONS_No_of_Participant_students || '-'],
            ['One Day Programs (No)', chapter.ONE_DAY_PROGRAMS_no || '-'],
            ['One Day Programs (Participants)', chapter.ONE_DAY_PROGRAMS_No_of_Participant_students || '-'],
            ['Industrial Visits (No)', chapter.INDUSTRIAL_VISITS_no || '-'],
            ['Industrial Visits (Participants)', chapter.INDUSTRIAL_VISITS_No_of_Participant_students || '-'],
            ['Innovation Products (No)', chapter.INNOVATION_PRODUCTS_no || '-'],
            ['Innovation Products (Participants)', chapter.INNOVATION_PRODUCTS_No_of_Participant_students || '-'],
            ['Mock Interviews (No)', chapter.MOCK_INTERVIEWS_no || '-'],
            ['Mock Interviews (Participants)', chapter.MOCK_INTERVIEWS_No_of_Participant_students || '-'],
            ['Quiz & Games (No)', chapter.QUIZ_GAMES_no || '-'],
            ['Quiz & Games (Participants)', chapter.QUIZ_GAMES_No_of_Participant_students || '-'],
            ['Personal Dev. Programs (No)', chapter.per_dev_prog_conducted_no || '-'],
            ['Personal Dev. Programs (Participants)', chapter.per_dev_prog_conducted_No_of_Participant_students || '-'],
            ['Panel Discussions (No)', chapter.PANEL_DISCUSSIONS_no || '-'],
            ['Panel Discussions (Participants)', chapter.PANEL_DISCUSSIONS_No_of_Participant_students || '-'],
            ['Panel of Speakers', chapter.panel_of_Speakers_opts || '-'],
            ['Students and Website', chapter.students_and_website || '-'],
            ['Regular Chapter Meetings', chapter.conducts_meetings_regularly || '-'],
            ['Image Building of College', chapter.Image_building_of_College || '-'],
            ['Atmosphere for Innovation', chapter.Creating_atmosphere_for_Innovation || '-'],
            ['Prevention of Ragging', chapter.Prevention_of_Campus_ragging || '-'],
            ['Contribution to College', chapter.Contribution_to_the_College_Comment || '-'],
            ['Qualifies for Award', chapter.qualifies_for_the_award || '-'],
            ['Accept the Award', chapter.accept_the_award || '-'],
            ['Visit to Your Premises', chapter.including_visit_to_your_premises || '-'],
            ['Willing to Present', chapter.willing_to_make_a_presentation || '-'],
            ['Support of the Proposal', chapter.support_of_the_proposal || '-'],
            ['Principal', chapter.Principal || '-'],
            ['Management Committee Chapter', chapter.mang_comm_chapt || '-'],
            ['Date', chapter.date ? new Date(chapter.date).toLocaleDateString() : '-']
        ];

        autoTable(doc, {
            startY: 30,
            head: [['Field', 'Details']],
            body: data,
            styles: { cellPadding: 2, fontSize: 10 },
            headStyles: { fillColor: [0, 123, 255] },
            alternateRowStyles: { fillColor: [240, 240, 240] }
        });

        doc.save(`HMA_Student_Chapter_${index + 1}.pdf`);
    };


    const [csr, setcsr] = useState([]);
    useEffect(() => {
        if (activeAward === 'csr') {
            axios.get('https://rvapi.emedha.in/pages/api/api/csr_award_of_the_year')
                .then(response => {
                    const data = response.data;
                    const safeArray = Array.isArray(data) ? data : [data];
                    setcsr(safeArray);
                    setForm1(safeArray.map(item => item.nominations_form1).filter(entry => entry !== null));
                    setForm2(safeArray.map(item => item.nominations_form2).filter(entry => entry !== null));
                    setCurrentPage(1);
                })
                .catch(error => {
                    console.error("Error fetching nominations:", error);
                });
        }
    }, [activeAward]);

    const handleDownloadCsrPdf = (item, index) => {
        const doc = new jsPDF();
        doc.setFontSize(18);
        doc.setTextColor(33, 37, 41);
        doc.text('CSR Award of the Year Details', 14, 22);
        doc.setFontSize(12);

        const csr = item.csr_award_of_the_year || {};

        const data = [
            ['Company Name', csr.company_name || '-'],
            ['Email', csr.email || '-'],
            ['Products/Services', csr.products_services || '-'],
            ['Large Undertakings', csr.large_undertakings ? 'Yes' : 'No'],
            ['Small Enterprises', csr.small_enterprises ? 'Yes' : 'No'],
            ['Public at Large', csr.public_at_large ? 'Yes' : 'No'],
            ['Exports', csr.exports ? 'Yes' : 'No'],
            ['Feedback Procedure', csr.feedback_procedure || '-'],
            ['Extent of Complaints', csr.extent_of_complaints || '-'],
            ['CSR Policy', csr.csr_policy || '-'],
            ['CSR by Top Management', csr.csr_by_top_management || '-'],
            ['CSR Activities Done', csr.csr_activity || '-'],

            // Activity Areas
            ['Health', csr.health ? 'Yes' : 'No'],
            ['Education', csr.education ? 'Yes' : 'No'],
            ['Environment Protection', csr.environment_protection ? 'Yes' : 'No'],
            ['Waste Management', csr.waste_management ? 'Yes' : 'No'],
            ['Skill Development', csr.skill_development ? 'Yes' : 'No'],
            ['Self Employment Support', csr.self_employment_support ? 'Yes' : 'No'],
            ['Community Development', csr.community_development ? 'Yes' : 'No'],
            ['Construction of Toilets', csr.construction_of_toilets ? 'Yes' : 'No'],
            ['Formation of SHGs / Cooperatives', csr.formation_of_shgs_for_cooperative_formation ? 'Yes' : 'No'],
            ['Thrift Among Women', csr.thrift_among_women ? 'Yes' : 'No'],
            ['Other Activities', csr.any_other_to_specify || '-'],
            ['Areas of Activities', csr.areas_of_activities || '-'],

            // Monitoring & Impact
            ['Top Management Review', csr.top_management_on_progress || '-'],
            ['Progress Comments', csr.top_management_on_progress_if_yes_comment || '-'],
            ['Amount Spent 2021–2022', csr.amount_spent_2021_2022 || '-'],
            ['Amount Spent 2022–2023', csr.amount_spent_2022_2023 || '-'],
            ['Amount Spent 2023–2024', csr.amount_spent_2023_2024 || '-'],
            ['% Spent to Turnover 2021–2022', csr.percent_spent_to_turnover_2021_2022 || '-'],
            ['% Spent to Turnover 2022–2023', csr.percent_spent_to_turnover_2022_2023 || '-'],
            ['% Spent to Turnover 2023–2024', csr.percent_spent_to_turnover_2023_2024 || '-'],
            ['Impact Assessment Comment', csr.impact_assessment_comment || '-'],

            // Employment Practices
            ['Training Provided', csr.training ? 'Yes' : 'No'],
            ['No Discrimination', csr.no_discrimination_towards_employees ? 'Yes' : 'No'],
            ['Retirement Policy', csr.clear_post_retirement_policy_for_employees ? 'Yes' : 'No'],
            ['Fair Legal Practices', csr.fair_legal_practices ? 'Yes' : 'No'],
            ['Safety Practices', csr.safety_practices ? 'Yes' : 'No'],
            ['Labour Unrest', csr.company_have_any_labour_unrest || '-'],
            ['Fair Reporting', csr.company_give_a_true_and_fair || '-'],
            ['Product/Service Integrity', csr.company_offer_products_services || '-'],
            ['CSR Sustainability', csr.sustainability_of_the_csr || '-'],
            ['Deserves the Award?', csr.company_deserves_this_award || '-'],
            ['Signature of CEO/MD', csr.signature_of_ceo_md || '-'],
            ['Name', csr.name || '-'],
            ['Date', csr.date && csr.date !== '0000-00-00' ? new Date(csr.date).toLocaleDateString() : '-']
        ];

        autoTable(doc, {
            startY: 30,
            head: [['Field', 'Details']],
            body: data,
            styles: { cellPadding: 2, fontSize: 10 },
            headStyles: { fillColor: [0, 123, 255] },
            alternateRowStyles: { fillColor: [240, 240, 240] }
        });

        doc.save(`CSR_Award_${index + 1}.pdf`);
    };



    const [hr, setHr] = useState([]);
    const [activeView, setActiveView] = useState('');
    useEffect(() => {
        axios.get('https://rvapi.emedha.in/pages/api/api/hr_manager')
            .then(response => {
                const data = response.data;
                const safeArray = Array.isArray(data) ? data : [data];

                // Set data for HR, Form 1, and Form 2
                setHr(safeArray);
                setForm1(safeArray.map(item => item.nominations_form1).filter(entry => entry !== null));
                setForm2(safeArray.map(item => item.nominations_form2).filter(entry => entry !== null));
                // Set pagination data
                setCurrentPage(1);
            })
            .catch(error => {
                console.error("Error fetching nominations:", error);
            });
    }, []); // Empty dep

    const handleDownloadPdf = (item, index) => {
        const doc = new jsPDF();
        doc.setFontSize(18);
        doc.setTextColor(33, 37, 41);
        doc.text('HR Manager Details', 14, 22);
        doc.setFontSize(12);
        const data = [
            ['Name', item.hr_manager.name || '-'],
            ['Email', item.hr_manager.email || '-'],
            ['Designation', item.hr_manager.name_designation || '-'],
            ['Applicant Name', item.hr_manager.name1 || '-'],
            ['Age', item.hr_manager.age || '-'],
            ['Experience (Total)', item.hr_manager.experience_total_years || '-'],
            ['Experience (Same Line)', item.hr_manager.experience_in_same_line || '-'],
            ['Experience (Same Organization)', item.hr_manager.experience_in_same_organization || '-'],
            ['Nominee Role', item.hr_manager.is_nominee_chief || '-'],
            ['Contribution Type', item.hr_manager.contribution_checkbox || '-'],
            ['Contribution Summary', item.hr_manager.contribution_comment || '-'],
            ['Organization Summary', item.hr_manager.organization || '-'],
            ['Date of Birth', new Date(item.hr_manager.date).toLocaleDateString() || '-'],
            ['Created At', new Date(item.hr_manager.created_at).toLocaleString() || '-']
        ];

        autoTable(doc, {
            startY: 30,
            head: [['Field', 'Details']],
            body: data,
            styles: { cellPadding: 2, fontSize: 10 },
            headStyles: { fillColor: [0, 123, 255] },
            alternateRowStyles: { fillColor: [240, 240, 240] }
        });

        doc.save(`HR_Manager_${index + 1}.pdf`);
    };

    const [manager, setManager] = useState([]);
    useEffect(() => {
        if (activeAward === 'manager') {
            axios.get('https://rvapi.emedha.in/pages/api/api/manager_of_the_year')
                .then(response => {
                    const data = response.data;
                    const safeArray = Array.isArray(data) ? data : [data];
                    setManager(safeArray);
                    setForm1(safeArray.map(item => item.nominations_form1).filter(entry => entry !== null));
                    setForm2(safeArray.map(item => item.nominations_form2).filter(entry => entry !== null));

                    setCurrentPage(1);
                })
                .catch(error => {
                    console.error("Error fetching nominations:", error);
                });
        }
    }, [activeAward]);

    const handleDownloadManagerOfTheYearPdf = (item, index) => {
        const doc = new jsPDF();
        doc.setFontSize(18);
        doc.setTextColor(33, 37, 41);
        doc.text('Manager of the Year Award Details', 14, 22);
        doc.setFontSize(12);

        const manager = item.manager_of_the_year || {};

        // Data to display in the PDF
        const data = [
            ['Email', manager.email || '-'],
            ['Name', manager.name || '-'],
            ['Name & Designation', manager.name_designation || '-'],
            ['Age', manager.age || '-'],
            ['Total Experience (Years)', manager.experience_total_years || '-'],
            ['Experience in Same Line', manager.experience_in_same_line || '-'],
            ['Experience in Same Organization', manager.experience_in_same_organization || '-'],
            ['Is Nominee Chief', manager.is_nominee_chief || '-'],
            ['Is Nominee First Generation', manager.is_nominee_first_generation || '-'],
            ['Contribution Checkbox', manager.contribution_checkbox || '-'],
            ['Contribution Comment', manager.contribution_comment || '-'],
            ['Contribution Performance', manager.contribution_performance || '-'],
            ['Eligible for Award', manager.eligible_for_award || '-'],
            ['Signature', manager.signature ? 'Available' : 'Not Available'],
            ['Created At', manager.created_at ? new Date(manager.created_at).toLocaleString() : '-']
        ];

        // Add the table to the PDF
        autoTable(doc, {
            startY: 30,
            head: [['Field', 'Details']],
            body: data,
            styles: { cellPadding: 2, fontSize: 10 },
            headStyles: { fillColor: [0, 123, 255] },
            alternateRowStyles: { fillColor: [240, 240, 240] }
        });

        // If signature image URL is available, embed it in the PDF
        if (manager.signature) {
            const imageUrl = manager.signature; // Assuming signature is a URL to the image
            const img = new Image();
            img.src = imageUrl;
            img.onload = function () {
                doc.addImage(img, 'JPEG', 15, doc.lastAutoTable.finalY + 10, 50, 20); // Adjust the size and position of the image
                doc.save(`Manager_Of_The_Year_Award_${index + 1}.pdf`);
            };
        } else {
            doc.save(`Manager_Of_The_Year_Award_${index + 1}.pdf`);
        }
    };


    const [young, setYoung] = useState([]);
    useEffect(() => {
        if (activeAward === 'young') {
            axios.get('https://rvapi.emedha.in/pages/api/api/young_manager_ofhe_year')
                .then(response => {
                    const data = response.data;
                    const safeArray = Array.isArray(data) ? data : [data];

                    setYoung(safeArray);
                    setForm1(safeArray.map(item => item.nominations_form1));
                    setForm2(safeArray.map(item => item.nominations_form2));

                    setCurrentPage(1);
                })
                .catch(error => {
                    console.error("Error fetching young_manager_ofhe_year nominations:", error);
                });
        }
    }, [activeAward]);

    const handleDownloadYoungPdf = (item, index) => {
        const doc = new jsPDF();
        doc.setFontSize(18);
        doc.setTextColor(33, 37, 41);
        doc.text('Young Manager of the Year Details', 14, 22);
        doc.setFontSize(12);

        const data = [
            ['Name', item.young_manager_ofhe_year.name || '-'],
            ['Email', item.young_manager_ofhe_year.email || '-'],
            ['Designation', item.young_manager_ofhe_year.designation || '-'],
            ['Applicant Name', item.young_manager_ofhe_year.name1 || '-'],
            ['Age', item.young_manager_ofhe_year.age || '-'],
            ['Technical PG', item.young_manager_ofhe_year.technical_pg || '-'],
            ['Technical Graduate', item.young_manager_ofhe_year.technical_graduate || '-'],
            ['Technical Others', item.young_manager_ofhe_year.technical_others || '-'],
            ['Financial PG', item.young_manager_ofhe_year.financial_pg || '-'],
            ['Financial Graduate', item.young_manager_ofhe_year.financial_graduate || '-'],
            ['Financial Others', item.young_manager_ofhe_year.financial_others || '-'],
            ['Management PG', item.young_manager_ofhe_year.management_pg || '-'],
            ['Management Graduate', item.young_manager_ofhe_year.management_graduate || '-'],
            ['Management Others', item.young_manager_ofhe_year.management_others || '-'],
            ['Professional PG', item.young_manager_ofhe_year.professional_pg || '-'],
            ['Professional Graduate', item.young_manager_ofhe_year.professional_graduate || '-'],
            ['Professional Others', item.young_manager_ofhe_year.professional_others || '-'],
            ['Other to Specialization PG', item.young_manager_ofhe_year.other_to_spe_pg || '-'],
            ['Other to Specialization Graduate', item.young_manager_ofhe_year.other_to_spe_graduate || '-'],
            ['Other to Specialization Others', item.young_manager_ofhe_year.other_to_spe_others || '-'],
            ['Experience (Total)', item.young_manager_ofhe_year.exp_total_in_year || '-'],
            ['Experience (Same Organization)', item.young_manager_ofhe_year.exp_in_same_org || '-'],
            ['Nominee Employee', item.young_manager_ofhe_year.nominee_emp || '-'],
            ['Nominee Summary', item.young_manager_ofhe_year.nominee_of_org || '-'],
            ['Increase in Turnover', item.young_manager_ofhe_year.Increase_in_turnover || '-'],
            ['Increase in Productivity', item.young_manager_ofhe_year.Increase_in_productivity || '-'],
            ['Increase in Quality Use of Quality Tools', item.young_manager_ofhe_year.Increase_in_quality_use_of_quality_tools || '-'],
            ['Increase in Areas of Operation', item.young_manager_ofhe_year.Increase_in_areas_of_operation || '-'],
            ['Introduction of New Practices', item.young_manager_ofhe_year.Introduction_of_new_practices || '-'],
            ['Innovations Done', item.young_manager_ofhe_year.Innovations_done || '-'],
            ['Improve HR Practices', item.young_manager_ofhe_year.Improve_HR_practices || '-'],
            ['Any Turnaround Activity', item.young_manager_ofhe_year.Any_turn_around_activity || '-'],
            ['Use of Innovative IT Practices (MIS)', item.young_manager_ofhe_year.Use_of_innovative_IT_practices_MIS || '-'],
            ['Development of R&D and Use of Technology', item.young_manager_ofhe_year.Development_of_R_D_and_use_of_the_technology || '-'],
            ['Energy Conservation', item.young_manager_ofhe_year.Energy_conservation || '-'],
            ['CSR Activities', item.young_manager_ofhe_year.CSR_activities || '-'],
            ['Received Any Recognition/Awards of Repute', item.young_manager_ofhe_year.Received_any_Recognition_awards_of_repute || '-'],
            ['Any Relevant Aspect to Specify', item.young_manager_ofhe_year.Any_relevant_aspect_to_specify || '-'],
            ['Contribution Performance', item.young_manager_ofhe_year.contribution_perfom || '-'],
            ['Eligibility Statement', item.young_manager_ofhe_year.eligible_for_this_award || '-'],
            ['Signature', item.young_manager_ofhe_year.signature || '-'],
            ['Date of Birth', new Date(item.young_manager_ofhe_year.date).toLocaleDateString() || '-']
        ];

        autoTable(doc, {
            startY: 30,
            head: [['Field', 'Details']],
            body: data,
            styles: { cellPadding: 2, fontSize: 10 },
            headStyles: { fillColor: [0, 123, 255] },
            alternateRowStyles: { fillColor: [240, 240, 240] }
        });

        doc.save(`Young_Manager_${index + 1}.pdf`);
    };



    const [it, setIt] = useState([]);
    useEffect(() => {
        if (activeAward === 'it') {
            axios.get('https://rvapi.emedha.in/pages/api/api/it_professional')
                .then(response => {
                    const data = response.data;
                    const safeArray = Array.isArray(data) ? data : [data];
                    setForm1(safeArray.map(item => item.nominations_form1).filter(entry => entry !== null));
                    setForm2(safeArray.map(item => item.nominations_form2).filter(entry => entry !== null));

                    setIt(safeArray);
                    setCurrentPage(1);
                })
                .catch(error => {
                    console.error("Error fetching nominations:", error);
                });
        }
    }, [activeAward]);

    const handleDownloadItProfessionalPdf = (item, index) => {
        const doc = new jsPDF();
        doc.setFontSize(18);
        doc.setTextColor(33, 37, 41);
        doc.text('IT Professional Award Details', 14, 22);
        doc.setFontSize(12);

        const itProf = item.it_professional || {};

        // Data to display in the PDF
        const data = [
            ['Email', itProf.email || '-'],
            ['Name & Designation', itProf.name_designation || '-'],
            ['Name', itProf.name || '-'],
            ['Age', itProf.age || '-'],
            ['Total Experience (Years)', itProf.experience_total_years || '-'],
            ['Experience in Same Line', itProf.experience_in_same_line || '-'],
            ['Experience in Same Organization', itProf.experience_in_same_organization || '-'],
            ['Is Nominee Chief', itProf.is_nominee_chief ? 'Yes' : 'No'],
            ['Contribution Comment', itProf.contribution_comment || '-'],
            ['Organization', itProf.organization || '-'],
            ['Previous Organization', itProf.previous_organization || '-'],
            ['Eligible for Award', itProf.eligible_for_award ? 'Yes' : 'No'],
            ['Date', itProf.date ? new Date(itProf.date).toLocaleDateString() : '-'],
            ['Signature', itProf.signature ? 'Available' : 'Not Available'],
            ['Created At', itProf.created_at ? new Date(itProf.created_at).toLocaleString() : '-']
        ];

        // Add the table to the PDF
        autoTable(doc, {
            startY: 30,
            head: [['Field', 'Details']],
            body: data,
            styles: { cellPadding: 2, fontSize: 10 },
            headStyles: { fillColor: [0, 123, 255] },
            alternateRowStyles: { fillColor: [240, 240, 240] }
        });

        // If signature image URL is available, embed it in the PDF
        if (itProf.signature) {
            const imageUrl = itProf.signature; // Assuming signature is a URL to the image
            const img = new Image();
            img.src = imageUrl;
            img.onload = function () {
                doc.addImage(img, 'JPEG', 15, doc.lastAutoTable.finalY + 10, 50, 20); // Adjust the size and position of the image
                doc.save(`IT_Professional_Award_${index + 1}.pdf`);
            };
        } else {
            doc.save(`IT_Professional_Award_${index + 1}.pdf`);
        }
    };


    const [small, setSmall] = useState([]);
    useEffect(() => {
        if (activeAward === 'small') {
            axios.get('https://rvapi.emedha.in/pages/api/api/small_scale_entp_of_the_year')
                .then(response => {
                    const data = response.data;
                    const safeArray = Array.isArray(data) ? data : [data];
                    setSmall(safeArray);
                    setForm1(safeArray.map(item => item.nominations_form1).filter(entry => entry !== null));
                    setForm2(safeArray.map(item => item.nominations_form2).filter(entry => entry !== null));

                    setCurrentPage(1);
                })
                .catch(error => {
                    console.error("Error fetching nominations:", error);
                });
        }
    }, [activeAward]);

    const handleDownloadSmallScalePdf = (item, index) => {
        const doc = new jsPDF();
        doc.setFontSize(18);
        doc.setTextColor(33, 37, 41);
        doc.text('Small Scale Entrepreneur of the Year Details', 14, 22);
        doc.setFontSize(12);

        const entp = item.small_scale_entp_of_the_year || {};

        const data = [
            ['Name', entp.Name || '-'],
            ['Email', entp.email || '-'],
            ['Designation', entp.Designation || '-'],
            ['Age', entp.Age || '-'],
            ['Technical PG', entp.Technical_PG || '-'],
            ['Technical Graduate', entp.Technical_Graduate || '-'],
            ['Technical Other', entp.Technical_Other || '-'],
            ['Financial PG', entp.Financial_PG || '-'],
            ['Financial Graduate', entp.Financial_Graduate || '-'],
            ['Financial Other', entp.Financial_Other || '-'],
            ['Management PG', entp.Management_PG || '-'],
            ['Management Graduate', entp.Management_Graduate || '-'],
            ['Management Other', entp.Management_Other || '-'],
            ['Professional PG', entp.Professional_PG || '-'],
            ['Professional Graduate', entp.Professional_Graduate || '-'],
            ['Professional Other', entp.Professional_Other || '-'],
            ['Other PG', entp.Other_PG || '-'],
            ['Other Graduate', entp.Other_Graduate || '-'],
            ['Other Other', entp.Other_Other || '-'],
            ['Experience Total', entp.Experience_Total || '-'],
            ['Experience In Same Line', entp.Experience_In_Same_Line || '-'],
            ['Experience In Same Organization', entp.Experience_In_Same_Organization || '-'],
            ['Nominee Chief Promoter', entp.Nominee_Chief_Promotor || '-'],
            ['Nominee First Generation', entp.Nominee_First_Generation || '-'],
            ['Business', entp.Business || '-'],
            ['Industry', entp.Industry || '-'],
            ['Agriculture', entp.Agriculture || '-'],
            ['Service', entp.Service || '-'],
            ['Other Technology', entp.Other_Tech || '-'],
            ['Family Background', entp.Family_Background_comment || '-'],
            ['Product/Service Comment', entp.Product_Service_comment || '-'],
            ['Source of Technology', entp.Source_of_Technology_Comment || '-'],
            ['Turnover Start', entp.Turnover_At_Start || '-'],
            ['Turnover Year1', entp.Turnover_Year1 || '-'],
            ['Turnover Year2', entp.Turnover_Year2 || '-'],
            ['Turnover Year3', entp.Turnover_Year3 || '-'],
            ['PAT Start', entp.PAT_At_Start || '-'],
            ['PAT Year1', entp.PAT_Year1 || '-'],
            ['PAT Year2', entp.PAT_Year2 || '-'],
            ['PAT Year3', entp.PAT_Year3 || '-'],
            ['Net Profit/Sales Start', entp.Net_Profit_Sales_At_Start || '-'],
            ['Net Profit/Sales Year1', entp.Net_Profit_Sales_Year1 || '-'],
            ['Net Profit/Sales Year2', entp.Net_Profit_Sales_Year2 || '-'],
            ['Net Profit/Sales Year3', entp.Net_Profit_Sales_Year3 || '-'],
            ['Current Ratio Start', entp.Current_Ratio_At_Start || '-'],
            ['Current Ratio Year1', entp.Current_Ratio_Year1 || '-'],
            ['Current Ratio Year2', entp.Current_Ratio_Year2 || '-'],
            ['Current Ratio Year3', entp.Current_Ratio_Year3 || '-'],
            ['Net Worth Start', entp.Net_Worth_At_Start || '-'],
            ['Net Worth Year1', entp.Net_Worth_Year1 || '-'],
            ['Net Worth Year2', entp.Net_Worth_Year2 || '-'],
            ['Net Worth Year3', entp.Net_Worth_Year3 || '-'],
            ['Contribution Performance', entp.Contribution_performance_comment || '-'],
            ['Eligible for Award', entp.Eligible_for_this_award_comment || '-'],
            ['Signature of CEO/MD', entp.Signature_of_CEO_MD || '-'],
            ['Date', entp.Date ? new Date(entp.Date).toLocaleDateString() : '-']
        ];

        autoTable(doc, {
            startY: 30,
            head: [['Field', 'Details']],
            body: data,
            styles: { cellPadding: 2, fontSize: 10 },
            headStyles: { fillColor: [0, 123, 255] },
            alternateRowStyles: { fillColor: [240, 240, 240] }
        });

        doc.save(`Small_Scale_Entrepreneur_${index + 1}.pdf`);
    };


    const [entrepreneur, setEntrepreneur] = useState([]);
    useEffect(() => {
        if (activeAward === 'entrepreneur') {
            axios.get('https://rvapi.emedha.in/pages/api/api/entrepreneur_of_the_year')
                .then(response => {
                    const data = response.data;
                    const safeArray = Array.isArray(data) ? data : [data];
                    setEntrepreneur(safeArray);
                    setForm1(safeArray.map(item => item.nominations_form1));
                    setForm2(safeArray.map(item => item.nominations_form2));
                    setCurrentPage(1);
                })
                .catch(error => {
                    console.error("Error fetching nominations:", error);
                });
        }
    }, [activeAward]);

    const handleDownloadEntrepreneurOfTheYearPdf = (item, index) => {
        const doc = new jsPDF();
        doc.setFontSize(18);
        doc.setTextColor(33, 37, 41);
        doc.text('Entrepreneur of the Year Award Details', 14, 22);
        doc.setFontSize(12);

        const entrepreneur = item.entrepreneur_of_the_year || {};

        // Data to display in the PDF - Mapped from the provided object
        const data = [
            ['Email', entrepreneur.email || '-'],
            ['Name', entrepreneur.name || '-'],
            ['Designation', entrepreneur.designation || '-'],
            ['Age', entrepreneur.age || '-'],
            ['Technical PG', entrepreneur.technical_pg || '-'],
            ['Technical Graduate', entrepreneur.technical_graduate || '-'],
            ['Technical Others', entrepreneur.technical_others || '-'],
            ['Financial PG', entrepreneur.financial_pg || '-'],
            ['Financial Graduate', entrepreneur.financial_graduate || '-'],
            ['Financial Others', entrepreneur.financial_others || '-'],
            ['Management PG', entrepreneur.management_pg || '-'],
            ['Management Graduate', entrepreneur.management_graduate || '-'],
            ['Management Others', entrepreneur.management_others || '-'],
            ['Professional PG', entrepreneur.professional_pg || '-'],
            ['Professional Graduate', entrepreneur.professional_graduate || '-'],
            ['Professional Others', entrepreneur.professional_others || '-'],
            ['Other to Specialization PG', entrepreneur.other_to_spe_pg || '-'],
            ['Other to Specialization Graduate', entrepreneur.other_to_spe_graduate || '-'],
            ['Other to Specialization Others', entrepreneur.other_to_spe_others || '-'],
            ['Experience Total in Years', entrepreneur.exp_total_in_year || '-'],
            ['Experience in Same Line', entrepreneur.exp_in_same_line || '-'],
            ['Experience in Same Organization', entrepreneur.exp_in_same_org || '-'],
            ['Nominee Chief Promoter', entrepreneur.is_nominee_chief_promoter || '-'],
            ['Nominee First Generation', entrepreneur.is_nominee_first_generation || '-'],
            ['Business', entrepreneur.business || '-'],
            ['Industry', entrepreneur.industry || '-'],
            ['Agriculture', entrepreneur.agriculture ? 'Yes' : 'No'],
            ['Service', entrepreneur.service || '-'],
            ['Other', entrepreneur.other || '-'],
            ['Family Background', entrepreneur.family_background || '-'],
            ['Traditional', entrepreneur.traditional ? 'Yes' : 'No'],
            ['Existing', entrepreneur.existing ? 'Yes' : 'No'],
            ['Innovative', entrepreneur.innovative ? 'Yes' : 'No'],
            ['Import Substitute', entrepreneur.import_substitute ? 'Yes' : 'No'],
            ['Product/Service', entrepreneur.product_Service || '-'],
            ['Indigenous', entrepreneur.indigenous ? 'Yes' : 'No'],
            ['Own R&D', entrepreneur.own_rd ? 'Yes' : 'No'],
            ['Imported', entrepreneur.imported ? 'Yes' : 'No'],
            ['Source of Technology', entrepreneur.source_of_technology || '-'],
            ['Investment at Start (Rs Cr)', entrepreneur.investment_in_rs_cr_at_start || '-'],
            ['Term Loan at Start (Rs Cr)', entrepreneur.term_loan_in_rs_cr_at_start || '-'],
            ['Turnover at Start (Rs Cr)', entrepreneur.turnover_in_rs_cr_at_start || '-'],
            ['PBT at Start (Rs Cr)', entrepreneur.pbt_in_rs_cr_at_start || '-'],
            ['Manpower at Start', entrepreneur.manpower_skilled_unskilled_at_start || '-'],
            ['Exports at Start (Rs Cr)', entrepreneur.exports_in_rs_cr_at_start || '-'],
            ['Investment at End (Rs Cr)', entrepreneur.investment_in_rs_cr_at_end || '-'],
            ['Term Loan at End (Rs Cr)', entrepreneur.term_loan_in_rs_cr_at_end || '-'],
            ['Turnover at End (Rs Cr)', entrepreneur.turnover_in_rs_cr_at_end || '-'],
            ['PBT at End (Rs Cr)', entrepreneur.pbt_in_rs_cr_at_end || '-'],
            ['Manpower at End', entrepreneur.manpower_skilled_unskilled_at_end || '-'],
            ['Exports at End (Rs Cr)', entrepreneur.exports_in_rs_cr_at_end || '-'],
            ['Turnover Year 1', entrepreneur.turnover_year_1 || '-'],
            ['PAT Year 1', entrepreneur.pat_year_1 || '-'],
            ['DER Year 1', entrepreneur.der_year_1 || '-'],
            ['Net Profit Sales Year 1', entrepreneur.net_profit_sales_year_1 || '-'],
            ['Current Ratio Year 1', entrepreneur.current_ratio_year_1 || '-'],
            ['Net Worth Year 1', entrepreneur.net_worth_year_1 || '-'],
            ['ROI Year 1', entrepreneur.roi_year_1 || '-'],
            ['Revenue per Employee Year 1', entrepreneur.revenue_per_employee_year_1 || '-'],
            ['Turnover Year 2', entrepreneur.turnover_year_2 || '-'],
            ['PAT Year 2', entrepreneur.pat_year_2 || '-'],
            ['DER Year 2', entrepreneur.der_year_2 || '-'],
            ['Net Profit Sales Year 2', entrepreneur.net_profit_sales_year_2 || '-'],
            ['Current Ratio Year 2', entrepreneur.current_ratio_year_2 || '-'],
            ['Net Worth Year 2', entrepreneur.net_worth_year_2 || '-'],
            ['ROI Year 2', entrepreneur.roi_year_2 || '-'],
            ['Revenue per Employee Year 2', entrepreneur.revenue_per_employee_year_2 || '-'],
            ['Turnover Year 3', entrepreneur.turnover_year_3 || '-'],
            ['PAT Year 3', entrepreneur.pat_year_3 || '-'],
            ['DER Year 3', entrepreneur.der_year_3 || '-'],
            ['Net Profit Sales Year 3', entrepreneur.net_profit_sales_year_3 || '-'],
            ['Current Ratio Year 3', entrepreneur.current_ratio_year_3 || '-'],
            ['Net Worth Year 3', entrepreneur.net_worth_year_3 || '-'],
            ['ROI Year 3', entrepreneur.roi_year_3 || '-'],
            ['Revenue per Employee Year 3', entrepreneur.revenue_per_employee_year_3 || '-'],
            ['ISO', entrepreneur.iso ? 'Yes' : 'No'],
            ['HACCP', entrepreneur.haccp ? 'Yes' : 'No'],
            ['WHO GMP FDA', entrepreneur.who_gmp_fda ? 'Yes' : 'No'],
            ['Any Other', entrepreneur.any_other ? 'Yes' : 'No'],
            ['Orientation Comment', entrepreneur.orientation_comment || '-'],
            ['Increase in Turnover', entrepreneur.increase_in_turnover ? 'Yes' : 'No'],
            ['Increase in Productivity', entrepreneur.increase_in_productivity ? 'Yes' : 'No'],
            ['Increase in Quality Tools', entrepreneur.increase_in_quality_tools ? 'Yes' : 'No'],
            ['Increase in Areas of Operation', entrepreneur.increase_in_areas_of_operation ? 'Yes' : 'No'],
            ['Introduction of New Practices', entrepreneur.introduction_of_new_practices ? 'Yes' : 'No'],
            ['Innovations Done', entrepreneur.innovations_done ? 'Yes' : 'No'],
            ['Improve HR Practices', entrepreneur.improve_hr_practices ? 'Yes' : 'No'],
            ['Any Turnaround Activity', entrepreneur.any_turnaround_activity ? 'Yes' : 'No'],
            ['Use of Innovative IT Practices', entrepreneur.use_of_innovative_it_practices ? 'Yes' : 'No'],
            ['Development of R&D and Technology', entrepreneur.development_of_rd_and_technology ? 'Yes' : 'No'],
            ['Energy Conservation', entrepreneur.energy_conservation ? 'Yes' : 'No'],
            ['CSR Activities', entrepreneur.csr_activities ? 'Yes' : 'No'],
            ['Received Any Recognition', entrepreneur.received_any_recognition ? 'Yes' : 'No'],
            ['Promoted Any Other Units', entrepreneur.promoted_any_other_units ? 'Yes' : 'No'],
            ['Comments', entrepreneur.comments || '-'],
            ['Nominee for Organisation', entrepreneur.nominee_for_organisation || '-'],
            ['Contribution Performance', entrepreneur.contribution_performance || '-'],
            ['Eligible for This Award', entrepreneur.eligible_for_this_award || '-'],
            ['Date', entrepreneur.date ? new Date(entrepreneur.date).toLocaleString() : '-'],
            ['CEO/MD Name', entrepreneur.ceo_md_name || '-']
        ];

        // Add the table to the PDF
        autoTable(doc, {
            startY: 30,
            head: [['Field', 'Details']],
            body: data,
            styles: { cellPadding: 2, fontSize: 10 },
            headStyles: { fillColor: [0, 123, 255] },
            alternateRowStyles: { fillColor: [240, 240, 240] }
        });

        // If signature image URL is available, embed it in the PDF
        if (entrepreneur.signature) {
            const imageUrl = entrepreneur.signature; // Assuming signature is a URL to the image
            const img = new Image();
            img.src = imageUrl;
            img.onload = function () {
                doc.addImage(img, 'JPEG', 15, doc.lastAutoTable.finalY + 10, 50, 20); // Adjust the size and position of the image
                doc.save(`Entrepreneur_Of_The_Year_Award_${index + 1}.pdf`);
            };
        } else {
            doc.save(`Entrepreneur_Of_The_Year_Award_${index + 1}.pdf`);
        }
    };



    const [pharma, setPharma] = useState([]);
    useEffect(() => {
        if (activeAward === 'pharma') {
            axios.get('https://rvapi.emedha.in/pages/api/api/pharma_leader0fthe_year')
                .then(response => {
                    const data = response.data;
                    const safeArray = Array.isArray(data) ? data : [data];
                    setPharma(safeArray);
                    setForm1(safeArray.map(item => item.nominations_form1).filter(entry => entry !== null));
                    setForm2(safeArray.map(item => item.nominations_form2).filter(entry => entry !== null));

                    setCurrentPage(1);
                })
                .catch(error => {
                    console.error("Error fetching nominations:", error);
                });
        }
    }, [activeAward]);

    const handleDownloadPharmaLeaderPdf = (item, index) => {
        const doc = new jsPDF();
        doc.setFontSize(18);
        doc.setTextColor(33, 37, 41);
        doc.text('Pharma Leader of the Year Award Details', 14, 22);
        doc.setFontSize(12);

        const pharma = item.pharma_leader0fthe_year || {};

        const data = [
            ['Email', pharma.email || '-'],
            ['Name', pharma.name || '-'],
            ['Alternate Name', pharma.name1 || '-'],
            ['Designation', pharma.designation || '-'],
            ['Age', pharma.age || '-'],
            ['Qualification ID', pharma.qualification_id || '-'],
            ['Experience Total', pharma.experience_total || '-'],
            ['Experience in Same Line', pharma.experience_same_line || '-'],
            ['Experience in Same Org', pharma.experience_same_org || '-'],
            ['Is Chief Promoter', pharma.is_chief_promoter ? 'Yes' : 'No'],
            ['Is First Gen Nominee', pharma.is_first_gen_nominee ? 'Yes' : 'No'],
            ['Family - Business', pharma.family_business ? 'Yes' : 'No'],
            ['Family - Industry', pharma.family_industry ? 'Yes' : 'No'],
            ['Family - Agriculture', pharma.family_agriculture ? 'Yes' : 'No'],
            ['Family - Service', pharma.family_service ? 'Yes' : 'No'],
            ['Family - Other', pharma.family_other || '-'],
            ['Family Comment', pharma.family_comment || '-'],
            ['Product - Traditional', pharma.product_traditional ? 'Yes' : 'No'],
            ['Product - Existing', pharma.product_existing ? 'Yes' : 'No'],
            ['Product - Innovative', pharma.product_innovative ? 'Yes' : 'No'],
            ['Product - Import Substitute', pharma.product_import_substitute ? 'Yes' : 'No'],
            ['Product Comment', pharma.product_comment || '-'],
            ['Source - Indigenous', pharma.source_indigenous ? 'Yes' : 'No'],
            ['Source - Own R&D', pharma.source_own_rd ? 'Yes' : 'No'],
            ['Source - Imported', pharma.source_imported ? 'Yes' : 'No'],
            ['Source Comment', pharma.source_comment || '-'],
            ['Investment at Start (Rs Cr)', pharma.investment_start || '-'],
            ['Term Loan at Start (Rs Cr)', pharma.term_loan_start || '-'],
            ['Turnover at Start (Rs Cr)', pharma.turnover_start || '-'],
            ['PBT at Start (Rs Cr)', pharma.pbt_start || '-'],
            ['Manpower at Start', pharma.manpower_start || '-'],
            ['Exports at Start (Rs Cr)', pharma.exports_start || '-'],
            ['Investment at End (Rs Cr)', pharma.investment_end || '-'],
            ['Term Loan at End (Rs Cr)', pharma.term_loan_end || '-'],
            ['Turnover at End (Rs Cr)', pharma.turnover_end || '-'],
            ['PBT at End (Rs Cr)', pharma.pbt_end || '-'],
            ['Manpower at End', pharma.manpower_end || '-'],
            ['Exports at End (Rs Cr)', pharma.exports_end || '-'],
            ['Financial Indicator ID', pharma.financial_indicator_id || '-'],
            ['ISO', pharma.orientation_iso ? 'Yes' : 'No'],
            ['HACCP', pharma.orientation_haccp ? 'Yes' : 'No'],
            ['WHO GMP/FDA', pharma.orientation_who_gmp_fda ? 'Yes' : 'No'],
            ['Any Other Orientation', pharma.orientation_other ? 'Yes' : 'No'],
            ['Orientation Comment', pharma.orientation_comment || '-'],
            ['Nominee Contribution', pharma.contribution_nominee ? 'Yes' : 'No'],
            ['Nominee Contribution Comment', pharma.contribution_nominee_comment || '-'],
            ['Performance Comment', pharma.contribution_performance_comment || '-'],
            ['Eligibility Comment', pharma.eligible_for_award_comment || '-'],
            ['Date', pharma.date ? new Date(pharma.date).toLocaleString() : '-'],
            ['Comments', pharma.comment || '-']
        ];

        autoTable(doc, {
            startY: 30,
            head: [['Field', 'Details']],
            body: data,
            styles: { cellPadding: 2, fontSize: 10 },
            headStyles: { fillColor: [0, 123, 255] },
            alternateRowStyles: { fillColor: [240, 240, 240] }
        });

        if (pharma.signature_url) {
            const imageUrl = pharma.signature_url;
            const img = new Image();
            img.src = imageUrl;
            img.onload = function () {
                doc.addImage(img, 'JPEG', 15, doc.lastAutoTable.finalY + 10, 50, 20);
                doc.save(`Pharma_Leader_Of_The_Year_Award_${index + 1}.pdf`);
            };
        } else {
            doc.save(`Pharma_Leader_Of_The_Year_Award_${index + 1}.pdf`);
        }
    };


    const [women, setWomen] = useState([]);
    useEffect(() => {
        if (activeAward === 'women') {
            axios.get('https://rvapi.emedha.in/pages/api/api/women_achiever_form3')
                .then(response => {
                    const data = response.data;
                    const safeArray = Array.isArray(data) ? data : [data];
                    setWomen(safeArray);

                    const form1Entries = safeArray.flatMap(item => item.nominations_form1 || []).filter(entry => entry !== null);
                    const form2Entries = safeArray.flatMap(item => item.nominations_form2 || []).filter(entry => entry !== null);

                    setForm1(form1Entries);
                    setForm2(form2Entries);
                    setCurrentPage(1);
                })
                .catch(error => {
                    console.error("Error fetching nominations:", error);
                });
        }
    }, [activeAward]);

    const handleDownloadWomenPdf = (item, index) => {
        const doc = new jsPDF();
        doc.setFontSize(18);
        doc.setTextColor(33, 37, 41);
        doc.text('Women Achiever of the Year Details', 14, 22);
        doc.setFontSize(12);

        const data = [
            ['Name', item.women_achiever_form3.name || '-'],
            ['Email', item.women_achiever_form3.email || '-'],
            ['Age', item.women_achiever_form3.age || '-'],
            ['Contributor Role', item.women_achiever_form3.contributor_role || '-'],
            ['First Generation Entrepreneur', item.women_achiever_form3.first_gen_entrepreneur || '-'],
            ['Summary of Contribution', item.women_achiever_form3.contribution_text || '-'],
            ['Detailed Comment / Bio', item.women_achiever_form3.comment1 || '-'],
            ['Signature Image', item.women_achiever_form3.signature_image ? 'Attached below' : '-'],
            ['Date', new Date(item.women_achiever_form3.date).toLocaleDateString() || '-']
        ];

        autoTable(doc, {
            startY: 30,
            head: [['Field', 'Details']],
            body: data,
            styles: { cellPadding: 2, fontSize: 10, valign: 'top' },
            headStyles: { fillColor: [255, 99, 132] },
            alternateRowStyles: { fillColor: [245, 245, 245] }
        });
        if (item.women_achiever_form3.signature_image) {
            const img = new Image();
            img.src = item.women_achiever_form3.signature_image;
            img.onload = () => {
                doc.addImage(img, 'JPEG', 14, doc.lastAutoTable.finalY + 10, 40, 20);
                doc.save(`Women_Achiever_${index + 1}.pdf`);
            };
        } else {
            doc.save(`Women_Achiever_${index + 1}.pdf`);
        }
    };



    const indexOfLastNomination = currentPage * nominationsPerPage;
    const indexOfFirstNomination = indexOfLastNomination - nominationsPerPage;
    const currentNominations = nominations.slice(indexOfFirstNomination, indexOfLastNomination);
    const totalPages = Math.ceil(nominations.length / nominationsPerPage);

    const handleNext = () => {
        if (currentPage < totalPages) setCurrentPage(prev => prev + 1);
    };

    const handlePrev = () => {
        if (currentPage > 1) setCurrentPage(prev => prev - 1);
    };

    const handleDownloadForm1Pdf = (form1Entry) => {
        const doc = new jsPDF();
        doc.setFontSize(18);
        doc.setTextColor(33, 37, 41);
        doc.text('Nomination Form Details', 14, 22);
        doc.setFontSize(12);

        const data = [
            ['Name', form1Entry.name || '-'],
            ['Address', form1Entry.address || '-'],
            ['Phone', form1Entry.phone || '-'],
            ['Email', form1Entry.email || '-'],
            ['Chief Promoter', form1Entry.chiefPromoter || '-'],
            ['Designation', form1Entry.designation || '-'],
            ['Year of Incorporation', form1Entry.yearOfIncorporation || '-'],
            ['Areas of Operation', form1Entry.areasOfOperation || '-'],
            ['Attend Awards', form1Entry.attendAwards || '-'],
            ['Willing to Supplement Info', form1Entry.willingToSupplement || '-'],
            ['Willing to Present at Ceremony', form1Entry.willingToPresent || '-'],
            ['Write-up Summary', form1Entry.writeUp || '-'],
            ['Other Contributions / Info', form1Entry.otherInfo || '-'],
            ['Statutory Approvals (Yes/No)', form1Entry.statutoryApprovals === "1" ? 'Yes' : 'No'],
            ['No PF/Tax Liabilities', form1Entry.noPFTaxLiabilities === "1" ? 'Yes' : 'No'],
            ['No Offences', form1Entry.noOffences === "1" ? 'Yes' : 'No'],
            ['Not an NPA', form1Entry.notNPA === "1" ? 'Yes' : 'No'],
            ['No Child Employment', form1Entry.noChildEmployment === "1" ? 'Yes' : 'No'],
            ['Applicant Name', form1Entry.applicantName || '-'],
            ['Applicant Designation', form1Entry.applicantDesignation || '-'],
            ['Applicant Email', form1Entry.applicantEmail || '-'],
            ['Applicant Phone', form1Entry.applicantPhone || '-']
        ];

        autoTable(doc, {
            startY: 30,
            head: [['Field', 'Details']],
            body: data,
            styles: { cellPadding: 2, fontSize: 10 },
            headStyles: { fillColor: [0, 123, 255] },
            alternateRowStyles: { fillColor: [240, 240, 240] }
        });

        doc.save(`Nomination_Form_${form1Entry.id}.pdf`);
    };


    const handleDownloadForm2Pdf = (form2Entry) => {
        const doc = new jsPDF();
        doc.setFontSize(18);
        doc.setTextColor(33, 37, 41);
        doc.text('Nomination Form 2 – Detailed Report', 14, 22);
        doc.setFontSize(12);

        const yesNo = (value) => value === 1 ? 'Yes' : 'No';

        const data = [
            ['Snapshot of Organisation', form2Entry.snapshot_of_organisation || '-'],
            ['Vision & Mission', form2Entry.vision || '-'],
            ['Achievements', form2Entry.achievements_of_organisation || '-'],
            ['Contribution to Exchequer', form2Entry.contribution_to_exchequer || '-'],
            ['Financials 2021-22 (in Cr)', form2Entry.financial_results_2021_22 || '-'],
            ['Financials 2022-23 (in Cr)', form2Entry.financial_results_2022_23 || '-'],
            ['Financials 2023-24 (in Cr)', form2Entry.financial_results_2023_24 || '-'],

            // Size of organization
            ['Org Size: Below 10', yesNo(form2Entry.size_of_organisation_below_10)],
            ['Org Size: 10-20', yesNo(form2Entry.size_of_organisation_10_20)],
            ['Org Size: 20-50', yesNo(form2Entry.size_of_organisation_20_50)],
            ['Org Size: Above 50', yesNo(form2Entry.size_of_organisation_above_50)],

            // Ownership
            ['Sole Proprietor', yesNo(form2Entry.ownership_sole_proprietor)],
            ['Partnership Firm', yesNo(form2Entry.ownership_partnership_firm)],
            ['Private Ltd. Company', yesNo(form2Entry.ownership_private_limited_company)],
            ['Limited Company', yesNo(form2Entry.ownership_limited_company)],
            ['Cooperative Society', yesNo(form2Entry.ownership_cooperative_society)],

            // Sector
            ['Sector: Private', yesNo(form2Entry.sector_private)],
            ['Sector: Public', yesNo(form2Entry.sector_public)],
            ['Sector: Govt Central', yesNo(form2Entry.sector_government_central)],
            ['Sector: Govt State', yesNo(form2Entry.sector_government_state)],
            ['Sector: Others', yesNo(form2Entry.sector_others)],

            // Employees
            ['Employees < 20', yesNo(form2Entry.no_of_employees_less_than_20)],
            ['Employees 20-50', yesNo(form2Entry.no_of_employees_20_50)],
            ['Employees 50-100', yesNo(form2Entry.no_of_employees_50_100)],
            ['Employees > 100', yesNo(form2Entry.no_of_employees_above_100)],

            // Product / Services (3 slots)
            ['Product/Service 1', form2Entry.main_products_services_description1 || '-'],
            ['Capacity 1', form2Entry.main_products_services_capacity1 || '-'],
            ['Product/Service 2', form2Entry.main_products_services_description2 || '-'],
            ['Capacity 2', form2Entry.main_products_services_capacity2 || '-'],
            ['Product/Service 3', form2Entry.main_products_services_description3 || '-'],
            ['Capacity 3', form2Entry.main_products_services_capacity3 || '-'],

            // Facilities
            ['Land Area', form2Entry.major_facilities_land_area || '-'],
            ['Factory Built-up Area', form2Entry.major_facilities_factory_built_up_area || '-'],
            ['Major Equipment', form2Entry.major_facilities_major_equipment || '-'],
            ['Specialized Facility', form2Entry.major_facilities_specialized_facility || '-'],
            ['Other Services', form2Entry.major_facilities_services || '-'],

            // Technology
            ['Traditional Tech', yesNo(form2Entry.technology_adopted_traditional)],
            ['Indigenous Tech', yesNo(form2Entry.technology_adopted_indigenous)],
            ['In-house R&D', yesNo(form2Entry.technology_adopted_in_house_r_d)],
            ['Foreign Technology', yesNo(form2Entry.technology_adopted_foreign_technology)],
            ['Franchise', yesNo(form2Entry.technology_adopted_franchise)],
            ['Tech Comment', form2Entry.technology_adopted_comment || '-'],

            // Quality Compliance
            ['ISO Certified', yesNo(form2Entry.quality_compliance_iso)],
            ['BIS Certified', yesNo(form2Entry.quality_compliance_bis)],
            ['GMP/WHO/FDA/HACCP', yesNo(form2Entry.quality_compliance_gmp_who_fda_haccp)],
            ['Other Certifications', yesNo(form2Entry.quality_compliance_other)],
            ['Compliance Comments', form2Entry.quality_compliance_comment || '-'],

            // Management Functions
            ['HR Department', yesNo(form2Entry.management_functions_human_resources_department)],
            ['Finance/Accounts', yesNo(form2Entry.management_functions_finance_accounts)],
            ['R&D', yesNo(form2Entry.management_functions_r_d)],
            ['Internal Audit', yesNo(form2Entry.management_functions_internal_audit)],
            ['Quality Assurance', yesNo(form2Entry.management_functions_quality_assurance)],
            ['Marketing/Business Dev.', yesNo(form2Entry.management_functions_marketing_business_development)],
            ['Other Functions', yesNo(form2Entry.management_functions_other)],
            ['Management Comment', form2Entry.management_functions_comment || '-'],

            // IT Use
            ['ERP', yesNo(form2Entry.level_of_it_intervention_use_of_erp)],
            ['Customized Software', yesNo(form2Entry.level_of_it_intervention_customized_software)],
            ['General Office Solutions', yesNo(form2Entry.level_of_it_intervention_general_office_solutions)],
            ['No IT Facility', yesNo(form2Entry.level_of_it_intervention_no_it_facility)],
            ['IT Comment', form2Entry.level_of_it_intervention_comment || '-'],

            // Awards / Recognition
            ['Award Recognition - Yes', yesNo(form2Entry.award_recognition_yes)],
            ['Award Recognition - No', yesNo(form2Entry.award_recognition_no)],
            ['Award Comment', form2Entry.award_recognition_comment || '-'],

            // Strategic Plan
            ['Strategic Plan - Yes', yesNo(form2Entry.strategic_plan_for_future_yes)],
            ['Strategic Plan - No', yesNo(form2Entry.strategic_plan_for_future_no)],
            ['Strategic Plan Comment', form2Entry.strategic_plan_for_future_comment || '-'],

            // Optional: Promoter / Product Info
            ['Chief Promoter Qualification', form2Entry.about_chief_promoter_educational_qualification || '-'],
            ['Chief Promoter Experience', form2Entry.about_chief_promoter_experience_in_line || '-'],
            ['First Gen Entrepreneur', yesNo(form2Entry.about_chief_promoter_first_generation_entrepreneur)],
            ['Promoter Contribution', form2Entry.about_chief_promoter_contribution_to_organisation || '-'],
            ['Promoter Details', form2Entry.about_chief_promoter_relevant_details || '-'],

            ['PDF Generated On', new Date().toLocaleString()]
        ];

        autoTable(doc, {
            startY: 30,
            head: [['Field', 'Details']],
            body: data,
            styles: { cellPadding: 2, fontSize: 10 },
            headStyles: { fillColor: [0, 123, 255] },
            alternateRowStyles: { fillColor: [240, 240, 240] }
        });

        doc.save(`Nomination_Form2_${form2Entry.id}.pdf`);
    };



    return (
        <div className="d-flex flex-column min-vh-100">
            <img src={H1} alt="header" className="img-fluid w-100" style={{ objectFit: 'cover', maxHeight: '200px' }} />

            <div className="container mt-4">
                <div className="d-flex flex-wrap justify-content-center gap-2">
                    <button className="btn btn-outline-dark d-flex align-items-center gap-2" onClick={() => setActiveAward('academician')}><FaAward /> Academician Award</button>
                    <button className="btn btn-outline-dark d-flex align-items-center gap-2" onClick={() => setActiveAward('student')}><FaAward /> Student Chapter</button>
                    <button className="btn btn-outline-dark d-flex align-items-center gap-2" onClick={() => setActiveAward('csr')}><FaAward /> CSR Award</button>
                    <button className="btn btn-outline-dark d-flex align-items-center gap-2" onClick={() => setActiveAward('hr')}><FaAward /> HR Manager</button>
                    <button className="btn btn-outline-dark d-flex align-items-center gap-2" onClick={() => setActiveAward('manager')}><FaAward /> Manager Award</button>
                    <button className="btn btn-outline-dark d-flex align-items-center gap-2" onClick={() => setActiveAward('women')}><FaAward /> Women Achiever</button>
                    <button className="btn btn-outline-dark d-flex align-items-center gap-2" onClick={() => setActiveAward('it')}><FaAward /> IT Professional</button>
                    <button className="btn btn-outline-dark d-flex align-items-center gap-2" onClick={() => setActiveAward('small')}><FaAward /> Small Scale Entrepreneur</button>
                    <button className="btn btn-outline-dark d-flex align-items-center gap-2" onClick={() => setActiveAward('young')}><FaAward /> Young Manager</button>
                    <button className="btn btn-outline-dark d-flex align-items-center gap-2" onClick={() => setActiveAward('entrepreneur')}><FaAward /> Entrepreneur</button>
                    <button className="btn btn-outline-dark d-flex align-items-center gap-2" onClick={() => setActiveAward('pharma')}><FaAward /> Pharma Leader</button>
                </div>
            </div>


            {activeAward === 'academician' && (
                <div className="container mt-4 mb-5">
                    <h2 className="mb-4 text-center text-primary">ACADEMICIAN EXCELLENCE AWARD </h2>

                    <div className="btn-group mb-3" role="group" aria-label="View Selector">
                        <button className={`btn btn-outline-primary ${activeView === 'academician' ? 'active' : ''}`} onClick={() => setActiveView('academician')}>ACADEMICIAN</button>
                        <button className={`btn btn-outline-primary ${activeView === 'form1' ? 'active' : ''}`} onClick={() => setActiveView('form1')}>Form 1</button>
                        <button className={`btn btn-outline-primary ${activeView === 'form2' ? 'active' : ''}`} onClick={() => setActiveView('form2')}>Form 2</button>
                    </div>

                    <div className="table-responsive">
                        <table className="table table-bordered table-striped table-hover" style={{ fontSize: '14px', border: "2px solid black" }}>
                            <thead className="table-dark">
                                <tr>
                                    {activeView === 'academician' && (
                                        <>
                                            <th>#</th>
                                            <th>Nominee Name</th>
                                            <th>Email</th>
                                            <th>Phone</th>
                                            <th>Designation</th>

                                            <th>Research Topic</th>
                                            <th>Articles Topic</th>
                                            <th>Books Topic</th>
                                            <th>Teaching College</th>
                                            <th>Teaching Years</th>

                                            <th>Action</th>
                                        </>
                                    )}
                                    {activeView === 'form1' && (
                                        <>
                                            <th>#</th>
                                            <th>Name</th>
                                            <th>Email</th>
                                            <th>Phone</th>
                                            <th>Designation</th>
                                            <th>Applicant Name</th>
                                            <th>Experience (Total)</th>
                                            <th>Experience (Same Line)</th>
                                            <th>Contribution</th>
                                            <th>Action</th>
                                        </>
                                    )}
                                    {activeView === 'form2' && (
                                        <>
                                            <th>#</th>
                                            <th>snapshot of the Organisation</th>
                                            <th>Vision</th>
                                            <th>Achievements</th>
                                            <th>Contribution to Exchequer</th>
                                            <th>Tech Adopted</th>
                                            <th>Quality Compliance</th>
                                            <th>Strategic Plan</th>
                                            <th>Action</th>
                                        </>
                                    )}
                                </tr>
                            </thead>
                            <tbody>
                                {activeView === 'academician' && currentNominations.length > 0 ? (
                                    currentNominations.map((item, index) => (
                                        <tr key={index}>
                                            <td>{indexOfFirstNomination + index + 1}</td>
                                            <td>{item.academician_excellence_award.name || '-'}</td>
                                            <td>{item.academician_excellence_award.email || '-'}</td>
                                            <td>{item.academician_excellence_award.age || '-'}</td>
                                            <td>{item.academician_excellence_award.designation || '-'}</td>

                                            <td>{item.academician_excellence_award.research_papers_published_paper_topic || '-'}</td>
                                            <td>{item.academician_excellence_award.articles_published_topic || '-'}</td>
                                            <td>{item.academician_excellence_award.books_published_topic_subject || '-'}</td>
                                            <td>{item.academician_excellence_award.experience_teaching_college || '-'}</td>
                                            <td>{item.academician_excellence_award.experience_teaching_years || '-'}</td>
                                            <td><button className="btn btn-sm btn-outline-danger" onClick={() => handleDownloadAcademicianExcellencePdf(item)} >Download PDF</button></td>

                                        </tr>
                                    ))
                                ) : activeView === 'form1' && form1.length > 0 ? (
                                    // Render Form 1 data
                                    form1.map((entry, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{entry.name || '-'}</td>
                                            <td>{entry.email || '-'}</td>
                                            <td>{entry.phone || '-'}</td>
                                            <td>{entry.designation || '-'}</td>
                                            <td>{entry.applicantName || '-'}</td>
                                            <td>{entry.experience_total_years || '-'}</td>
                                            <td>{entry.experience_in_same_line || '-'}</td>
                                            <td>{entry.contribution_checkbox || '-'}</td>
                                            <td><button className="btn btn-sm btn-outline-danger" onClick={() => handleDownloadForm1Pdf(entry)} >Download PDF</button></td>
                                        </tr>
                                    ))
                                ) : activeView === 'form2' && form2.length > 0 ? (
                                    // Render Form 2 data
                                    form2.map((entry, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{entry.snapshot_of_organisation || '-'}</td>
                                            <td>{entry.vision || '-'}</td>
                                            <td>{entry.achievements_of_organisation || '-'}</td>
                                            <td>{entry.contribution_to_exchequer || '-'}</td>
                                            <td>{entry.technology_adopted_indigenous || '-'}</td>
                                            <td>{entry.quality_compliance_iso || '-'}</td>
                                            <td>{entry.strategic_plan_for_future_comment || '-'}</td>
                                            <td><button className="btn btn-sm btn-outline-danger" onClick={() => handleDownloadForm2Pdf(entry)} >Download PDF</button></td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr><td colSpan="12" className="text-center">No nominations available</td></tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    {/* Pagination Controls */}
                    <div className="d-flex justify-content-between align-items-center mt-3">
                        <button className="btn btn-outline-primary" onClick={handlePrev} disabled={currentPage === 1}>
                            Previous
                        </button>
                        <span className="fw-bold">Page {currentPage} of {totalPages}</span>
                        <button className="btn btn-outline-primary" onClick={handleNext} disabled={currentPage === totalPages}>
                            Next
                        </button>
                    </div>
                </div>
            )}

            {activeAward === 'student' && (
                <div className="container mt-4 mb-5">
                    <h2 className="mb-4 text-center text-primary">HMA’s BEST STUDENT CHAPTER AWARD</h2>

                    <div className="btn-group mb-3" role="group" aria-label="View Selector">
                        <button className={`btn btn-outline-primary ${activeView === 'student' ? 'active' : ''}`} onClick={() => setActiveView('student')}>BEST STUDENT</button>
                        <button className={`btn btn-outline-primary ${activeView === 'form1' ? 'active' : ''}`} onClick={() => setActiveView('form1')}>Form 1</button>
                        <button className={`btn btn-outline-primary ${activeView === 'form2' ? 'active' : ''}`} onClick={() => setActiveView('form2')}>Form 2</button>
                    </div>

                    <div className="table-responsive">
                        <table className="table table-bordered table-striped table-hover" style={{ fontSize: '14px', border: "2px solid black" }}>
                            <thead className="table-dark">
                                <tr>
                                    {activeView === 'student' && (
                                        <>
                                            <th>#</th>
                                            <th>College Name</th>
                                            <th>College Email</th>
                                            <th>Principal Name</th>
                                            <th>Principal Phone</th>
                                            <th>Student Name</th>
                                            <th>University Affiliated</th>
                                            <th>Date of Incorporation</th>
                                            <th>No. of Student Members</th>
                                            <th>Action</th>
                                        </>
                                    )}
                                    {activeView === 'form1' && (
                                        <>
                                            <th>#</th>
                                            <th>Name</th>
                                            <th>Email</th>
                                            <th>Phone</th>
                                            <th>Designation</th>
                                            <th>Applicant Name</th>
                                            <th>Experience (Total)</th>
                                            <th>Experience (Same Line)</th>
                                            <th>Contribution</th>
                                            <th>Action</th>
                                        </>
                                    )}
                                    {activeView === 'form2' && (
                                        <>
                                            <th>#</th>
                                            <th>snapshot of the Organisation</th>
                                            <th>Vision</th>
                                            <th>Achievements</th>
                                            <th>Contribution to Exchequer</th>
                                            <th>Tech Adopted</th>
                                            <th>Quality Compliance</th>
                                            <th>Strategic Plan</th>
                                            <th>Action</th>
                                        </>
                                    )}
                                </tr>
                            </thead>
                            <tbody>
                                {activeView === 'student' && excellenceaward.length > 0 ? (
                                    excellenceaward.map((item, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{item.hma_best_student_chapter_award.college_name || '-'}</td>
                                            <td>{item.hma_best_student_chapter_award.email || '-'}</td>
                                            <td>{item.hma_best_student_chapter_award.Name_Of_Principal || '-'}</td>
                                            <td>{item.hma_best_student_chapter_award.Phone || '-'}</td>
                                            <td>{item.hma_best_student_chapter_award.Name_of_the_Student || '-'}</td>
                                            <td>{item.hma_best_student_chapter_award.University_Affiliated || '-'}</td>
                                            <td>{item.hma_best_student_chapter_award.Date_of_Incorporation ? new Date(item.Date_of_Incorporation).toLocaleDateString() : '-'}</td>
                                            <td>{item.hma_best_student_chapter_award.No_of_student_Members || '-'}</td>
                                            <td><button className="btn btn-sm btn-outline-danger" onClick={() => handleDownloadHmaStudentPdf(item)} >Download PDF</button></td>
                                        </tr>
                                    ))
                                ) : activeView === 'form1' && form1.length > 0 ? (
                                    // Render Form 1 data
                                    form1.map((entry, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{entry.name || '-'}</td>
                                            <td>{entry.email || '-'}</td>
                                            <td>{entry.phone || '-'}</td>
                                            <td>{entry.designation || '-'}</td>
                                            <td>{entry.applicantName || '-'}</td>
                                            <td>{entry.experience_total_years || '-'}</td>
                                            <td>{entry.experience_in_same_line || '-'}</td>
                                            <td>{entry.contribution_checkbox || '-'}</td>
                                            <td><button className="btn btn-sm btn-outline-danger" onClick={() => handleDownloadForm1Pdf(entry)} >Download PDF</button></td>
                                        </tr>
                                    ))
                                ) : activeView === 'form2' && form2.length > 0 ? (
                                    // Render Form 2 data
                                    form2.map((entry, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{entry.snapshot_of_organisation || '-'}</td>
                                            <td>{entry.vision || '-'}</td>
                                            <td>{entry.achievements_of_organisation || '-'}</td>
                                            <td>{entry.contribution_to_exchequer || '-'}</td>
                                            <td>{entry.technology_adopted_indigenous || '-'}</td>
                                            <td>{entry.quality_compliance_iso || '-'}</td>
                                            <td>{entry.strategic_plan_for_future_comment || '-'}</td>
                                            <td><button className="btn btn-sm btn-outline-danger" onClick={() => handleDownloadForm2Pdf(entry)} >Download PDF</button></td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr><td colSpan="9" className="text-center">No nominations available</td></tr>
                                )}
                            </tbody>

                        </table>
                    </div>

                    {/* Pagination Controls */}
                    <div className="d-flex justify-content-between align-items-center mt-3">
                        <button className="btn btn-outline-primary" onClick={handlePrev} disabled={currentPage === 1}>
                            Previous
                        </button>
                        <span className="fw-bold">Page {currentPage} of {totalPages}</span>
                        <button className="btn btn-outline-primary" onClick={handleNext} disabled={currentPage === totalPages}>
                            Next
                        </button>
                    </div>
                </div>
            )}

            {activeAward === 'csr' && (
                <div className="container mt-4 mb-5">
                    <h2 className="mb-4 text-center text-primary">CSR AWARD OF THE YEAR</h2>

                    <div className="btn-group mb-3" role="group" aria-label="View Selector">
                        <button className={`btn btn-outline-primary ${activeView === 'csr' ? 'active' : ''}`} onClick={() => setActiveView('csr')}>CSR AWARD</button>
                        <button className={`btn btn-outline-primary ${activeView === 'form1' ? 'active' : ''}`} onClick={() => setActiveView('form1')}>Form 1</button>
                        <button className={`btn btn-outline-primary ${activeView === 'form2' ? 'active' : ''}`} onClick={() => setActiveView('form2')}>Form 2</button>
                    </div>

                    <div className="table-responsive">
                        <table className="table table-bordered table-striped table-hover" style={{ fontSize: '14px', border: "2px solid black" }}>
                            <thead className="table-dark">
                                <tr>
                                    {activeView === 'csr' && (
                                        <>
                                            <th>#</th>
                                            <th>Company Name</th>
                                            <th>Email</th>
                                            <th>csr Activity</th>
                                            <th>csr by top management</th>
                                            <th>Products services</th>
                                            <th>CSR Policy</th>
                                            <th>Amount Spent (2023-2024)</th>
                                            <th>Impact Assessment</th>
                                            <th>Action</th>
                                        </>
                                    )}
                                    {activeView === 'form1' && (
                                        <>
                                            <th>#</th>
                                            <th>Name</th>
                                            <th>Email</th>
                                            <th>Phone</th>
                                            <th>Designation</th>
                                            <th>Applicant Name</th>
                                            <th>Experience (Total)</th>
                                            <th>Experience (Same Line)</th>
                                            <th>Contribution</th>
                                            <th>Action</th>
                                        </>
                                    )}
                                    {activeView === 'form2' && (
                                        <>
                                            <th>#</th>
                                            <th>snapshot of the Organisation</th>
                                            <th>Vision</th>
                                            <th>Achievements</th>
                                            <th>Contribution to Exchequer</th>
                                            <th>Tech Adopted</th>
                                            <th>Quality Compliance</th>
                                            <th>Strategic Plan</th>
                                            <th>Action</th>
                                        </>
                                    )}
                                </tr>
                            </thead>
                            <tbody>
                                {activeView === 'csr' && csr.length > 0 ? (
                                    csr.map((item, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{item.csr_award_of_the_year.company_name || '-'}</td>
                                            <td>{item.csr_award_of_the_year.email || '-'}</td>
                                            <td>{item.csr_award_of_the_year.csr_activity || '-'}</td>
                                            <td>{item.csr_award_of_the_year.csr_by_top_management || '-'}</td>
                                            <td>{item.csr_award_of_the_year.products_services || '-'}</td>
                                            <td>{item.csr_award_of_the_year.csr_policy || '-'}</td>
                                            <td>{item.csr_award_of_the_year.amount_spent_2023_2024 || '-'}</td>
                                            <td>{item.csr_award_of_the_year.impact_assessment_comment || '-'}</td>
                                            <td><button className="btn btn-sm btn-outline-danger" onClick={() => handleDownloadCsrPdf(item)} >Download PDF</button></td>
                                        </tr>
                                    ))
                                ) : activeView === 'form1' && form1.length > 0 ? (
                                    // Render Form 1 data
                                    form1.map((entry, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{entry.name || '-'}</td>
                                            <td>{entry.email || '-'}</td>
                                            <td>{entry.phone || '-'}</td>
                                            <td>{entry.designation || '-'}</td>
                                            <td>{entry.applicantName || '-'}</td>
                                            <td>{entry.experience_total_years || '-'}</td>
                                            <td>{entry.experience_in_same_line || '-'}</td>
                                            <td>{entry.contribution_checkbox || '-'}</td>
                                            <td><button className="btn btn-sm btn-outline-danger" onClick={() => handleDownloadForm1Pdf(entry)} >Download PDF</button></td>
                                        </tr>
                                    ))
                                ) : activeView === 'form2' && form2.length > 0 ? (
                                    // Render Form 2 data
                                    form2.map((entry, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{entry.snapshot_of_organisation || '-'}</td>
                                            <td>{entry.vision || '-'}</td>
                                            <td>{entry.achievements_of_organisation || '-'}</td>
                                            <td>{entry.contribution_to_exchequer || '-'}</td>
                                            <td>{entry.technology_adopted_indigenous || '-'}</td>
                                            <td>{entry.quality_compliance_iso || '-'}</td>
                                            <td>{entry.strategic_plan_for_future_comment || '-'}</td>
                                            <td><button className="btn btn-sm btn-outline-danger" onClick={() => handleDownloadForm2Pdf(entry)} >Download PDF</button></td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr><td colSpan="10" className="text-center">No nominations available</td></tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    {/* Pagination Controls */}
                    <div className="d-flex justify-content-between align-items-center mt-3">
                        <button className="btn btn-outline-primary" onClick={handlePrev} disabled={currentPage === 1}>
                            Previous
                        </button>
                        <span className="fw-bold">Page {currentPage} of {totalPages}</span>
                        <button className="btn btn-outline-primary" onClick={handleNext} disabled={currentPage === totalPages}>
                            Next
                        </button>
                    </div>
                </div>
            )}

            {activeAward === 'hr' && (
                <div className="container mt-4 mb-5">
                    <h2 className="mb-4 text-center text-primary">HR MANAGER OF THE YEAR</h2>

                    <div className="btn-group mb-3" role="group" aria-label="View Selector">
                        <button className={`btn btn-outline-primary ${activeView === 'hr' ? 'active' : ''}`} onClick={() => setActiveView('hr')}>HR Manager</button>
                        <button className={`btn btn-outline-primary ${activeView === 'form1' ? 'active' : ''}`} onClick={() => setActiveView('form1')}>Form 1</button>
                        <button className={`btn btn-outline-primary ${activeView === 'form2' ? 'active' : ''}`} onClick={() => setActiveView('form2')}>Form 2</button>
                    </div>

                    <div className="table-responsive">
                        <table className="table table-bordered table-striped table-hover" style={{ fontSize: '14px', border: "2px solid black" }}>
                            <thead className="table-dark">
                                <tr>
                                    {activeView === 'hr' && (
                                        <>
                                            <th>#</th>
                                            <th>Name</th>
                                            <th>Email</th>
                                            <th>Age</th>
                                            <th>Designation</th>
                                            <th>Experience (Total)</th>
                                            <th>Experience (Same Line)</th>
                                            <th>Experience in same organization</th>
                                            <th>is_nominee_chief</th>
                                            <th>Applicant Name</th>
                                            <th>Action</th>
                                        </>
                                    )}
                                    {activeView === 'form1' && (
                                        <>
                                            <th>#</th>
                                            <th>Name</th>
                                            <th>Email</th>
                                            <th>Phone</th>
                                            <th>Designation</th>
                                            <th>Applicant Name</th>
                                            <th>Experience (Total)</th>
                                            <th>Experience (Same Line)</th>
                                            <th>Contribution</th>
                                            <th>Action</th>
                                        </>
                                    )}
                                    {activeView === 'form2' && (
                                        <>
                                            <th>#</th>
                                            <th>snapshot of the Organisation</th>
                                            <th>Vision</th>
                                            <th>Achievements</th>
                                            <th>Contribution to Exchequer</th>
                                            <th>Tech Adopted</th>
                                            <th>Quality Compliance</th>
                                            <th>Strategic Plan</th>
                                            <th>Action</th>
                                        </>
                                    )}
                                </tr>
                            </thead>
                            <tbody>
                                {/* Render HR Manager data */}
                                {activeView === 'hr' && hr.length > 0 ? (
                                    hr.map((item, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{item.hr_manager.name || '-'}</td>
                                            <td>{item.hr_manager.email || '-'}</td>
                                            <td>{item.hr_manager.age || '-'}</td>
                                            <td>{item.hr_manager.name_designation || '-'}</td>
                                            <td>{item.hr_manager.experience_total_years || '-'}</td>
                                            <td>{item.hr_manager.experience_in_same_line || '-'}</td>
                                            <td>{item.hr_manager.experience_in_same_organization || '-'}</td>
                                            <td>{item.hr_manager.is_nominee_chief || '-'}</td>
                                            <td>{item.hr_manager.name1 || '-'}</td>
                                            <td><button className="btn btn-sm btn-outline-danger" onClick={() => handleDownloadPdf(item)} >Download PDF</button></td>
                                        </tr>
                                    ))
                                ) : activeView === 'form1' && form1.length > 0 ? (
                                    // Render Form 1 data
                                    form1.map((entry, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{entry.name || '-'}</td>
                                            <td>{entry.email || '-'}</td>
                                            <td>{entry.phone || '-'}</td>
                                            <td>{entry.designation || '-'}</td>
                                            <td>{entry.applicantName || '-'}</td>
                                            <td>{entry.experience_total_years || '-'}</td>
                                            <td>{entry.experience_in_same_line || '-'}</td>
                                            <td>{entry.contribution_checkbox || '-'}</td>
                                            <td><button className="btn btn-sm btn-outline-danger" onClick={() => handleDownloadForm1Pdf(entry)} >Download PDF</button></td>
                                        </tr>
                                    ))
                                ) : activeView === 'form2' && form2.length > 0 ? (
                                    // Render Form 2 data
                                    form2.map((entry, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{entry.snapshot_of_organisation || '-'}</td>
                                            <td>{entry.vision || '-'}</td>
                                            <td>{entry.achievements_of_organisation || '-'}</td>
                                            <td>{entry.contribution_to_exchequer || '-'}</td>
                                            <td>{entry.technology_adopted_indigenous || '-'}</td>
                                            <td>{entry.quality_compliance_iso || '-'}</td>
                                            <td>{entry.strategic_plan_for_future_comment || '-'}</td>
                                            <td><button className="btn btn-sm btn-outline-danger" onClick={() => handleDownloadForm2Pdf(entry)} >Download PDF</button></td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr><td colSpan="8" className="text-center">No data available</td></tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    {/* Pagination Controls */}
                    <div className="d-flex justify-content-between align-items-center mt-3">
                        <button className="btn btn-outline-primary" onClick={handlePrev} disabled={currentPage === 1}>
                            Previous
                        </button>
                        <span className="fw-bold">Page {currentPage} of {totalPages}</span>
                        <button className="btn btn-outline-primary" onClick={handleNext} disabled={currentPage === totalPages}>
                            Next
                        </button>
                    </div>
                </div>
            )}

            {activeAward === 'manager' && (
                <div className="container mt-4 mb-5">
                    <h2 className="mb-4 text-center text-primary"> MANAGER OF THE YEAR</h2>

                    <div className="btn-group mb-3" role="group" aria-label="View Selector">
                        <button className={`btn btn-outline-primary ${activeView === 'manager' ? 'active' : ''}`} onClick={() => setActiveView('manager')}>Manager</button>
                        <button className={`btn btn-outline-primary ${activeView === 'form1' ? 'active' : ''}`} onClick={() => setActiveView('form1')}>Form 1</button>
                        <button className={`btn btn-outline-primary ${activeView === 'form2' ? 'active' : ''}`} onClick={() => setActiveView('form2')}>Form 2</button>
                    </div>

                    <div className="table-responsive">
                        <table className="table table-bordered table-striped table-hover" style={{ fontSize: '14px', border: "2px solid black" }}>
                            <thead className="table-dark">
                                <tr>
                                    {activeView === 'manager' && (
                                        <>
                                            <th>#</th>
                                            <th>Name</th>
                                            <th>Email</th>
                                            <th>Designation</th>
                                            <th>Experience (Total)</th>
                                            <th>Experience (Same Line)</th>
                                            <th>Contribution</th>
                                            <th>Action</th>
                                        </>
                                    )}
                                    {activeView === 'form1' && (
                                        <>
                                            <th>#</th>
                                            <th>Name</th>
                                            <th>Email</th>
                                            <th>Phone</th>
                                            <th>Designation</th>
                                            <th>Applicant Name</th>
                                            <th>Experience (Total)</th>
                                            <th>Experience (Same Line)</th>
                                            <th>Contribution</th>
                                            <th>Action</th>
                                        </>
                                    )}
                                    {activeView === 'form2' && (
                                        <>
                                            <th>#</th>
                                            <th>snapshot of the Organisation</th>
                                            <th>Vision</th>
                                            <th>Achievements</th>
                                            <th>Contribution to Exchequer</th>
                                            <th>Tech Adopted</th>
                                            <th>Quality Compliance</th>
                                            <th>Strategic Plan</th>
                                            <th>Action</th>
                                        </>
                                    )}
                                </tr>
                            </thead>
                            <tbody>
                                {activeView === 'manager' && manager.length > 0 ? (
                                    manager.map((item, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{item.manager_of_the_year.name || '-'}</td>
                                            <td>{item.manager_of_the_year.email || '-'}</td>
                                            <td>{item.manager_of_the_year.name_designation || '-'}</td>
                                            <td>{item.manager_of_the_year.experience_total_years || '-'}</td>
                                            <td>{item.manager_of_the_year.experience_in_same_line || '-'}</td>
                                            <td>{item.manager_of_the_year.contribution_checkbox || '-'}</td>
                                            <td><button className="btn btn-sm btn-outline-danger" onClick={() => handleDownloadManagerOfTheYearPdf(item)} >Download PDF</button></td>
                                        </tr>
                                    ))
                                ) : activeView === 'form1' && form1.length > 0 ? (
                                    // Render Form 1 data
                                    form1.map((entry, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{entry.name || '-'}</td>
                                            <td>{entry.email || '-'}</td>
                                            <td>{entry.phone || '-'}</td>
                                            <td>{entry.designation || '-'}</td>
                                            <td>{entry.applicantName || '-'}</td>
                                            <td>{entry.experience_total_years || '-'}</td>
                                            <td>{entry.experience_in_same_line || '-'}</td>
                                            <td>{entry.contribution_checkbox || '-'}</td>
                                            <td><button className="btn btn-sm btn-outline-danger" onClick={() => handleDownloadForm1Pdf(entry)} >Download PDF</button></td>
                                        </tr>
                                    ))
                                ) : activeView === 'form2' && form2.length > 0 ? (
                                    // Render Form 2 data
                                    form2.map((entry, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{entry.snapshot_of_organisation || '-'}</td>
                                            <td>{entry.vision || '-'}</td>
                                            <td>{entry.achievements_of_organisation || '-'}</td>
                                            <td>{entry.contribution_to_exchequer || '-'}</td>
                                            <td>{entry.technology_adopted_indigenous || '-'}</td>
                                            <td>{entry.quality_compliance_iso || '-'}</td>
                                            <td>{entry.strategic_plan_for_future_comment || '-'}</td>
                                            <td><button className="btn btn-sm btn-outline-danger" onClick={() => handleDownloadForm2Pdf(entry)} >Download PDF</button></td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr><td colSpan="10" className="text-center">No nominations available</td></tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    {/* Pagination Controls */}
                    <div className="d-flex justify-content-between align-items-center mt-3">
                        <button className="btn btn-outline-primary" onClick={handlePrev} disabled={currentPage === 1}>
                            Previous
                        </button>
                        <span className="fw-bold">Page {currentPage} of {totalPages}</span>
                        <button className="btn btn-outline-primary" onClick={handleNext} disabled={currentPage === totalPages}>
                            Next
                        </button>
                    </div>
                </div>
            )}

            {activeAward === 'entrepreneur' && (
                <div className="container mt-4 mb-5">
                    <h2 className="mb-4 text-center text-primary">Form 3 - ENTREPRENEUR OF THE YEAR</h2>

                    <div className="btn-group mb-3" role="group" aria-label="View Selector">
                        <button className={`btn btn-outline-primary ${activeView === 'entrepreneur' ? 'active' : ''}`} onClick={() => setActiveView('entrepreneur')}>ENTREPRENEUR</button>
                        <button className={`btn btn-outline-primary ${activeView === 'form1' ? 'active' : ''}`} onClick={() => setActiveView('form1')}>Form 1</button>
                        <button className={`btn btn-outline-primary ${activeView === 'form2' ? 'active' : ''}`} onClick={() => setActiveView('form2')}>Form 2</button>
                    </div>

                    <div className="table-responsive">
                        <table className="table table-bordered table-striped table-hover" style={{ fontSize: '14px', border: "2px solid black" }}>
                            <thead className="table-dark">
                                <tr>
                                    {activeView === 'entrepreneur' && (
                                        <>
                                            <th>#</th>
                                            <th>Name</th>
                                            <th>Email</th>
                                            <th>Age</th>
                                            <th>Designation</th>
                                            <th>Applicant Name</th>
                                            <th>Experience (Total)</th>
                                            <th>Experience (Same Line)</th>
                                            <th>Contribution</th>
                                            <th>Action</th>
                                        </>
                                    )}
                                    {activeView === 'form1' && (
                                        <>
                                            <th>#</th>
                                            <th>Name</th>
                                            <th>Email</th>
                                            <th>Phone</th>
                                            <th>Designation</th>
                                            <th>Applicant Name</th>
                                            <th>Experience (Total)</th>
                                            <th>Experience (Same Line)</th>
                                            <th>Contribution</th>
                                            <th>Action</th>
                                        </>
                                    )}
                                    {activeView === 'form2' && (
                                        <>
                                            <th>#</th>
                                            <th>snapshot of the Organisation</th>
                                            <th>Vision</th>
                                            <th>Achievements</th>
                                            <th>Contribution to Exchequer</th>
                                            <th>Tech Adopted</th>
                                            <th>Quality Compliance</th>
                                            <th>Strategic Plan</th>
                                            <th>Action</th>
                                        </>
                                    )}
                                </tr>
                            </thead>
                            <tbody>
                                {activeView === 'entrepreneur' && entrepreneur.length > 0 ? (
                                    entrepreneur.map((item, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{item.entrepreneur_of_the_year.name || '-'}</td>
                                            <td>{item.entrepreneur_of_the_year.email || '-'}</td>
                                            <td>{item.entrepreneur_of_the_year.age || '-'}</td>
                                            <td>{item.entrepreneur_of_the_year.designation || '-'}</td>
                                            <td>{item.entrepreneur_of_the_year.nominee_for_organisation || '-'}</td>
                                            <td>{item.entrepreneur_of_the_year.exp_total_in_year || '-'}</td>
                                            <td>{item.entrepreneur_of_the_year.exp_in_same_line || '-'}</td>
                                            <td>{item.entrepreneur_of_the_year.contribution_performance || '-'}</td>
                                            <td><button className="btn btn-sm btn-outline-danger" onClick={() => handleDownloadEntrepreneurOfTheYearPdf(item)} >Download PDF</button></td>
                                        </tr>
                                    ))
                                ) : activeView === 'form1' && form1.length > 0 ? (
                                    // Render Form 1 data
                                    form1.map((entry, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{entry.name || '-'}</td>
                                            <td>{entry.email || '-'}</td>
                                            <td>{entry.phone || '-'}</td>
                                            <td>{entry.designation || '-'}</td>
                                            <td>{entry.applicantName || '-'}</td>
                                            <td>{entry.experience_total_years || '-'}</td>
                                            <td>{entry.experience_in_same_line || '-'}</td>
                                            <td>{entry.contribution_checkbox || '-'}</td>
                                            <td><button className="btn btn-sm btn-outline-danger" onClick={() => handleDownloadForm1Pdf(entry)} >Download PDF</button></td>
                                        </tr>
                                    ))
                                ) : activeView === 'form2' && form2.length > 0 ? (
                                    // Render Form 2 data
                                    form2.map((entry, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{entry.snapshot_of_organisation || '-'}</td>
                                            <td>{entry.vision || '-'}</td>
                                            <td>{entry.achievements_of_organisation || '-'}</td>
                                            <td>{entry.contribution_to_exchequer || '-'}</td>
                                            <td>{entry.technology_adopted_indigenous || '-'}</td>
                                            <td>{entry.quality_compliance_iso || '-'}</td>
                                            <td>{entry.strategic_plan_for_future_comment || '-'}</td>
                                            <td><button className="btn btn-sm btn-outline-danger" onClick={() => handleDownloadForm2Pdf(entry)} >Download PDF</button></td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr><td colSpan="10" className="text-center">No nominations available</td></tr>
                                )}
                            </tbody>

                        </table>
                    </div>

                    {/* Pagination Controls */}
                    <div className="d-flex justify-content-between align-items-center mt-3">
                        <button className="btn btn-outline-primary" onClick={handlePrev} disabled={currentPage === 1}>
                            Previous
                        </button>
                        <span className="fw-bold">Page {currentPage} of {totalPages}</span>
                        <button className="btn btn-outline-primary" onClick={handleNext} disabled={currentPage === totalPages}>
                            Next
                        </button>
                    </div>
                </div>
            )}

            {activeAward === 'it' && (
                <div className="container mt-4 mb-5">
                    <h2 className="mb-4 text-center text-primary">IT PROFESSIONAL OF THE YEAR</h2>

                    <div className="btn-group mb-3" role="group" aria-label="View Selector">
                        <button className={`btn btn-outline-primary ${activeView === 'it' ? 'active' : ''}`} onClick={() => setActiveView('it')}>IT PROFESSIONAL</button>
                        <button className={`btn btn-outline-primary ${activeView === 'form1' ? 'active' : ''}`} onClick={() => setActiveView('form1')}>Form 1</button>
                        <button className={`btn btn-outline-primary ${activeView === 'form2' ? 'active' : ''}`} onClick={() => setActiveView('form2')}>Form 2</button>
                    </div>

                    <div className="table-responsive">
                        <table className="table table-bordered table-striped table-hover" style={{ fontSize: '14px', border: "2px solid black" }}>
                            <thead className="table-dark">
                                <tr>
                                    {activeView === 'it' && (
                                        <>
                                            <th>#</th>
                                            <th>Name</th>
                                            <th>Email</th>
                                            <th>Phone</th>
                                            <th>Age</th>
                                            <th>Designation</th>
                                            <th>Applicant Name</th>
                                            <th>Experience (Total)</th>
                                            <th>Experience (Same Line)</th>
                                            <th>Contribution</th>
                                            <th>Action</th>
                                        </>
                                    )}
                                    {activeView === 'form1' && (
                                        <>
                                            <th>#</th>
                                            <th>Name</th>
                                            <th>Email</th>
                                            <th>Phone</th>
                                            <th>Designation</th>
                                            <th>Applicant Name</th>
                                            <th>Experience (Total)</th>
                                            <th>Experience (Same Line)</th>
                                            <th>Contribution</th>
                                            <th>Action</th>
                                        </>
                                    )}
                                    {activeView === 'form2' && (
                                        <>
                                            <th>#</th>
                                            <th>snapshot of the Organisation</th>
                                            <th>Vision</th>
                                            <th>Achievements</th>
                                            <th>Contribution to Exchequer</th>
                                            <th>Tech Adopted</th>
                                            <th>Quality Compliance</th>
                                            <th>Strategic Plan</th>
                                            <th>Action</th>
                                        </>
                                    )}
                                </tr>
                            </thead>
                            <tbody>
                                {activeView === 'it' && it.length > 0 ? (
                                    it.map((item, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{item.it_professional.name || '-'}</td>
                                            <td>{item.it_professional.email || '-'}</td>
                                            <td>{item.it_professional.phone || '-'}</td>
                                            <td>{item.it_professional.age || '-'}</td> {/* was item.Age */}
                                            <td>{item.it_professional.designation || '-'}</td>
                                            <td>{item.it_professional.applicantName || '-'}</td> {/* was item.Name1 */}
                                            <td>{item.it_professional.experience_total_years || '-'}</td> {/* was item.Experience_Total */}
                                            <td>{item.it_professional.experience_in_same_line || '-'}</td> {/* was item.Experience_In_Same_Line */}
                                            <td>{item.it_professional.contribution_comment || '-'}</td>
                                            <td><button className="btn btn-sm btn-outline-danger" onClick={() => handleDownloadItProfessionalPdf(item)} >Download PDF</button></td>
                                        </tr>
                                    ))
                                ) : activeView === 'form1' && form1.length > 0 ? (
                                    // Render Form 1 data
                                    form1.map((entry, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{entry.name || '-'}</td>
                                            <td>{entry.email || '-'}</td>
                                            <td>{entry.phone || '-'}</td>
                                            <td>{entry.designation || '-'}</td>
                                            <td>{entry.applicantName || '-'}</td>
                                            <td>{entry.experience_total_years || '-'}</td>
                                            <td>{entry.experience_in_same_line || '-'}</td>
                                            <td>{entry.contribution_checkbox || '-'}</td>
                                            <td><button className="btn btn-sm btn-outline-danger" onClick={() => handleDownloadForm1Pdf(entry)} >Download PDF</button></td>
                                        </tr>
                                    ))
                                ) : activeView === 'form2' && form2.length > 0 ? (
                                    // Render Form 2 data
                                    form2.map((entry, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{entry.snapshot_of_organisation || '-'}</td>
                                            <td>{entry.vision || '-'}</td>
                                            <td>{entry.achievements_of_organisation || '-'}</td>
                                            <td>{entry.contribution_to_exchequer || '-'}</td>
                                            <td>{entry.technology_adopted_indigenous || '-'}</td>
                                            <td>{entry.quality_compliance_iso || '-'}</td>
                                            <td>{entry.strategic_plan_for_future_comment || '-'}</td>
                                            <td><button className="btn btn-sm btn-outline-danger" onClick={() => handleDownloadForm2Pdf(entry)} >Download PDF</button></td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="10" className="text-center">No nominations available</td>
                                    </tr>
                                )}
                            </tbody>


                        </table>
                    </div>

                    {/* Pagination Controls */}
                    <div className="d-flex justify-content-between align-items-center mt-3">
                        <button className="btn btn-outline-primary" onClick={handlePrev} disabled={currentPage === 1}>
                            Previous
                        </button>
                        <span className="fw-bold">Page {currentPage} of {totalPages}</span>
                        <button className="btn btn-outline-primary" onClick={handleNext} disabled={currentPage === totalPages}>
                            Next
                        </button>
                    </div>
                </div>
            )}

            {activeAward === 'small' && (
                <div className="container mt-4 mb-5">
                    <h2 className="mb-4 text-center text-primary">SAMLL SCALE Entrepreneur of the Year</h2>

                    <div className="btn-group mb-3" role="group" aria-label="View Selector">
                        <button className={`btn btn-outline-primary ${activeView === 'small' ? 'active' : ''}`} onClick={() => setActiveView('small')}>SAMLL SCALE Entrepreneur</button>
                        <button className={`btn btn-outline-primary ${activeView === 'form1' ? 'active' : ''}`} onClick={() => setActiveView('form1')}>Form 1</button>
                        <button className={`btn btn-outline-primary ${activeView === 'form2' ? 'active' : ''}`} onClick={() => setActiveView('form2')}>Form 2</button>
                    </div>

                    <div className="table-responsive">
                        <table className="table table-bordered table-striped table-hover" style={{ fontSize: '14px', border: "2px solid black" }}>
                            <thead className="table-dark">
                                <tr>
                                    {activeView === 'small' && (
                                        <>
                                            <th>#</th>
                                            <th>Name</th>
                                            <th>Email</th>
                                            <th>Age</th>
                                            <th>Designation</th>
                                            <th>Applicant Name</th>
                                            <th>Experience (Total)</th>
                                            <th>Experience (Same Line)</th>
                                            <th>Action</th>
                                        </>
                                    )}
                                    {activeView === 'form1' && (
                                        <>
                                            <th>#</th>
                                            <th>Name</th>
                                            <th>Email</th>
                                            <th>Phone</th>
                                            <th>Designation</th>
                                            <th>Applicant Name</th>
                                            <th>Experience (Total)</th>
                                            <th>Experience (Same Line)</th>
                                            <th>Contribution</th>
                                            <th>Action</th>
                                        </>
                                    )}
                                    {activeView === 'form2' && (
                                        <>
                                            <th>#</th>
                                            <th>snapshot of the Organisation</th>
                                            <th>Vision</th>
                                            <th>Achievements</th>
                                            <th>Contribution to Exchequer</th>
                                            <th>Tech Adopted</th>
                                            <th>Quality Compliance</th>
                                            <th>Strategic Plan</th>
                                            <th>Action</th>
                                        </>
                                    )}
                                </tr>
                            </thead>
                            <tbody>
                                {activeView === 'small' && small.length > 0 ? (
                                    small.map((item, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{item.small_scale_entp_of_the_year.Name || '-'}</td>
                                            <td>{item.small_scale_entp_of_the_year.email || '-'}</td>
                                            <td>{item.small_scale_entp_of_the_year.Age || '-'}</td>
                                            <td>{item.small_scale_entp_of_the_year.designation || '-'}</td>
                                            <td>{item.small_scale_entp_of_the_year.Name1 || '-'}</td>
                                            <td>{item.small_scale_entp_of_the_year.Experience_Total || '-'}</td>
                                            <td>{item.small_scale_entp_of_the_year.Experience_In_Same_Line || '-'}</td>
                                            <td><button className="btn btn-sm btn-outline-danger" onClick={() => handleDownloadSmallScalePdf(item)} >Download PDF</button></td>
                                        </tr>
                                    ))
                                ) : activeView === 'form1' && form1.length > 0 ? (
                                    // Render Form 1 data
                                    form1.map((entry, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{entry.name || '-'}</td>
                                            <td>{entry.email || '-'}</td>
                                            <td>{entry.phone || '-'}</td>
                                            <td>{entry.designation || '-'}</td>
                                            <td>{entry.applicantName || '-'}</td>
                                            <td>{entry.experience_total_years || '-'}</td>
                                            <td>{entry.experience_in_same_line || '-'}</td>
                                            <td>{entry.contribution_checkbox || '-'}</td>
                                            <td><button className="btn btn-sm btn-outline-danger" onClick={() => handleDownloadForm1Pdf(entry)} >Download PDF</button></td>
                                        </tr>
                                    ))
                                ) : activeView === 'form2' && form2.length > 0 ? (
                                    // Render Form 2 data
                                    form2.map((entry, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{entry.snapshot_of_organisation || '-'}</td>
                                            <td>{entry.vision || '-'}</td>
                                            <td>{entry.achievements_of_organisation || '-'}</td>
                                            <td>{entry.contribution_to_exchequer || '-'}</td>
                                            <td>{entry.technology_adopted_indigenous || '-'}</td>
                                            <td>{entry.quality_compliance_iso || '-'}</td>
                                            <td>{entry.strategic_plan_for_future_comment || '-'}</td>
                                            <td><button className="btn btn-sm btn-outline-danger" onClick={() => handleDownloadForm2Pdf(entry)} >Download PDF</button></td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr><td colSpan="10" className="text-center">No nominations available</td></tr>
                                )}
                            </tbody>

                        </table>
                    </div>

                    {/* Pagination Controls */}
                    <div className="d-flex justify-content-between align-items-center mt-3">
                        <button className="btn btn-outline-primary" onClick={handlePrev} disabled={currentPage === 1}>
                            Previous
                        </button>
                        <span className="fw-bold">Page {currentPage} of {totalPages}</span>
                        <button className="btn btn-outline-primary" onClick={handleNext} disabled={currentPage === totalPages}>
                            Next
                        </button>
                    </div>
                </div>
            )}

            {activeAward === 'young' && (
                <div className="container mt-4 mb-5">
                    <h2 className="mb-4 text-center text-primary">YOUNG MANAGER OF THE YEAR</h2>

                    <div className="btn-group mb-3" role="group" aria-label="View Selector">
                        <button className={`btn btn-outline-primary ${activeView === 'young' ? 'active' : ''}`} onClick={() => setActiveView('young')}>YOUNG Manager</button>
                        <button className={`btn btn-outline-primary ${activeView === 'form1' ? 'active' : ''}`} onClick={() => setActiveView('form1')}>Form 1</button>
                        <button className={`btn btn-outline-primary ${activeView === 'form2' ? 'active' : ''}`} onClick={() => setActiveView('form2')}>Form 2</button>
                    </div>

                    <div className="table-responsive">
                        <table className="table table-bordered table-striped table-hover" style={{ fontSize: '14px', border: "2px solid black" }}>
                            <thead className="table-dark">
                                <tr>
                                    {activeView === 'young' && (
                                        <>
                                            <th>#</th>
                                            <th>Name</th>
                                            <th>Email</th>
                                            <th>Age</th>
                                            <th>Designation</th>
                                            <th>Applicant Name</th>
                                            <th>Experience (Total)</th>
                                            <th>Experience (Same Line)</th>
                                            <th>contribution_perfom</th>
                                            <th>Action</th>
                                        </>
                                    )}
                                    {activeView === 'form1' && (
                                        <>
                                            <th>#</th>
                                            <th>Name</th>
                                            <th>Email</th>
                                            <th>Phone</th>
                                            <th>Designation</th>
                                            <th>Applicant Name</th>
                                            <th>Experience (Total)</th>
                                            <th>Experience (Same Line)</th>
                                            <th>Contribution</th>
                                            <th>Action</th>
                                        </>
                                    )}
                                    {activeView === 'form2' && (
                                        <>
                                            <th>#</th>
                                            <th>snapshot of the Organisation</th>
                                            <th>Vision</th>
                                            <th>Achievements</th>
                                            <th>Contribution to Exchequer</th>
                                            <th>Tech Adopted</th>
                                            <th>Quality Compliance</th>
                                            <th>Strategic Plan</th>
                                            <th>Action</th>
                                        </>
                                    )}
                                </tr>
                            </thead>
                            <tbody>
                                {activeView === 'young' && young.length > 0 ? (
                                    young.map((item, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{item.young_manager_ofhe_year.name || '-'}</td>
                                            <td>{item.young_manager_ofhe_year.email || '-'}</td>
                                            <td>{item.young_manager_ofhe_year.age || '-'}</td>
                                            <td>{item.young_manager_ofhe_year.designation || '-'}</td>
                                            <td>{item.young_manager_ofhe_year.name1 || '-'}</td>
                                            <td>{item.young_manager_ofhe_year.exp_total_in_year || '-'}</td>
                                            <td>{item.young_manager_ofhe_year.exp_in_same_org || '-'}</td>
                                            <td>{item.young_manager_ofhe_year.contribution_perfom || '-'}</td>
                                            <td><button className="btn btn-sm btn-outline-danger" onClick={() => handleDownloadYoungPdf(item)} >Download PDF</button></td>
                                        </tr>
                                    ))
                                ) : activeView === 'form1' && form1.length > 0 ? (
                                    // Render Form 1 data
                                    form1.map((entry, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{entry.name || '-'}</td>
                                            <td>{entry.email || '-'}</td>
                                            <td>{entry.phone || '-'}</td>
                                            <td>{entry.designation || '-'}</td>
                                            <td>{entry.applicantName || '-'}</td>
                                            <td>{entry.experience_total_years || '-'}</td>
                                            <td>{entry.experience_in_same_line || '-'}</td>
                                            <td>{entry.contribution_checkbox || '-'}</td>
                                            <td><button className="btn btn-sm btn-outline-danger" onClick={() => handleDownloadForm1Pdf(entry)} >Download PDF</button></td>
                                        </tr>
                                    ))
                                ) : activeView === 'form2' && form2.length > 0 ? (
                                    // Render Form 2 data
                                    form2.map((entry, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{entry.snapshot_of_organisation || '-'}</td>
                                            <td>{entry.vision || '-'}</td>
                                            <td>{entry.achievements_of_organisation || '-'}</td>
                                            <td>{entry.contribution_to_exchequer || '-'}</td>
                                            <td>{entry.technology_adopted_indigenous || '-'}</td>
                                            <td>{entry.quality_compliance_iso || '-'}</td>
                                            <td>{entry.strategic_plan_for_future_comment || '-'}</td>
                                            <td><button className="btn btn-sm btn-outline-danger" onClick={() => handleDownloadForm2Pdf(entry)} >Download PDF</button></td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr><td colSpan="10" className="text-center">No nominations available</td></tr>
                                )}
                            </tbody>

                        </table>
                    </div>

                    {/* Pagination Controls */}
                    <div className="d-flex justify-content-between align-items-center mt-3">
                        <button className="btn btn-outline-primary" onClick={handlePrev} disabled={currentPage === 1}>
                            Previous
                        </button>
                        <span className="fw-bold">Page {currentPage} of {totalPages}</span>
                        <button className="btn btn-outline-primary" onClick={handleNext} disabled={currentPage === totalPages}>
                            Next
                        </button>
                    </div>
                </div>
            )}

            {activeAward === 'pharma' && (
                <div className="container mt-4 mb-5">
                    <h2 className="mb-4 text-center text-primary">PHARMA LEADER OF THE YEAR</h2>

                    <div className="btn-group mb-3" role="group" aria-label="View Selector">
                        <button className={`btn btn-outline-primary ${activeView === 'pharma' ? 'active' : ''}`} onClick={() => setActiveView('pharma')}>Pharma</button>
                        <button className={`btn btn-outline-primary ${activeView === 'form1' ? 'active' : ''}`} onClick={() => setActiveView('form1')}>Form 1</button>
                        <button className={`btn btn-outline-primary ${activeView === 'form2' ? 'active' : ''}`} onClick={() => setActiveView('form2')}>Form 2</button>
                    </div>

                    <div className="table-responsive">
                        <table className="table table-bordered table-striped table-hover" style={{ fontSize: '14px', border: "2px solid black" }}>
                            <thead className="table-dark">
                                <tr>
                                    {activeView === 'pharma' && (
                                        <>
                                            <th>#</th>
                                            <th>Name</th>
                                            <th>Email</th>

                                            <th>Age</th>
                                            <th>Designation</th>
                                            <th>Applicant Name</th>
                                            <th>Experience (Total)</th>
                                            <th>Experience (Same Line)</th>

                                            <th>Action</th>
                                        </>
                                    )}
                                    {activeView === 'form1' && (
                                        <>
                                            <th>#</th>
                                            <th>Name</th>
                                            <th>Email</th>
                                            <th>Phone</th>
                                            <th>Designation</th>
                                            <th>Applicant Name</th>
                                            <th>Experience (Total)</th>
                                            <th>Experience (Same Line)</th>
                                            <th>Contribution</th>
                                            <th>Action</th>
                                        </>
                                    )}
                                    {activeView === 'form2' && (
                                        <>
                                            <th>#</th>
                                            <th>snapshot of the Organisation</th>
                                            <th>Vision</th>
                                            <th>Achievements</th>
                                            <th>Contribution to Exchequer</th>
                                            <th>Tech Adopted</th>
                                            <th>Quality Compliance</th>
                                            <th>Strategic Plan</th>
                                            <th>Action</th>
                                        </>
                                    )}
                                </tr>
                            </thead>
                            <tbody>
                                {activeView === 'pharma' && pharma.length > 0 ? (
                                    pharma.map((item, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{item.pharma_leader0fthe_year.name || '-'}</td>
                                            <td>{item.pharma_leader0fthe_year.email || '-'}</td>
                                            <td>{item.pharma_leader0fthe_year.age || '-'}</td>
                                            <td>{item.pharma_leader0fthe_year.designation || '-'}</td>
                                            <td>{item.pharma_leader0fthe_year.name1 || '-'}</td>
                                            <td>{item.pharma_leader0fthe_year.experience_total || '-'}</td>
                                            <td>{item.pharma_leader0fthe_year.experience_same_line || '-'}</td>
                                            <td><button className="btn btn-sm btn-outline-danger" onClick={() => handleDownloadPharmaLeaderPdf(item)} >Download PDF</button></td>
                                        </tr>
                                    ))
                                ) : activeView === 'form1' && form1.length > 0 ? (
                                    // Render Form 1 data
                                    form1.map((entry, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{entry.name || '-'}</td>
                                            <td>{entry.email || '-'}</td>
                                            <td>{entry.phone || '-'}</td>
                                            <td>{entry.designation || '-'}</td>
                                            <td>{entry.applicantName || '-'}</td>
                                            <td>{entry.experience_total_years || '-'}</td>
                                            <td>{entry.experience_in_same_line || '-'}</td>
                                            <td>{entry.contribution_checkbox || '-'}</td>
                                            <td><button className="btn btn-sm btn-outline-danger" onClick={() => handleDownloadForm1Pdf(entry)} >Download PDF</button></td>
                                        </tr>
                                    ))
                                ) : activeView === 'form2' && form2.length > 0 ? (
                                    // Render Form 2 data
                                    form2.map((entry, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{entry.snapshot_of_organisation || '-'}</td>
                                            <td>{entry.vision || '-'}</td>
                                            <td>{entry.achievements_of_organisation || '-'}</td>
                                            <td>{entry.contribution_to_exchequer || '-'}</td>
                                            <td>{entry.technology_adopted_indigenous || '-'}</td>
                                            <td>{entry.quality_compliance_iso || '-'}</td>
                                            <td>{entry.strategic_plan_for_future_comment || '-'}</td>
                                            <td><button className="btn btn-sm btn-outline-danger" onClick={() => handleDownloadForm2Pdf(entry)} >Download PDF</button></td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr><td colSpan="10" className="text-center">No nominations available</td></tr>
                                )}
                            </tbody>

                        </table>
                    </div>

                    {/* Pagination Controls */}
                    <div className="d-flex justify-content-between align-items-center mt-3">
                        <button className="btn btn-outline-primary" onClick={handlePrev} disabled={currentPage === 1}>
                            Previous
                        </button>
                        <span className="fw-bold">Page {currentPage} of {totalPages}</span>
                        <button className="btn btn-outline-primary" onClick={handleNext} disabled={currentPage === totalPages}>
                            Next
                        </button>
                    </div>
                </div>
            )}

            {activeAward === 'women' && (
                <div className="container mt-4 mb-5">
                    <h2 className="mb-4 text-center text-primary">WOMEN ACHIEVER AWARD OF EXCELLENCE</h2>

                    <div className="btn-group mb-3" role="group" aria-label="View Selector">
                        <button className={`btn btn-outline-primary ${activeView === 'women' ? 'active' : ''}`} onClick={() => setActiveView('women')}>WOMEN</button>
                        <button className={`btn btn-outline-primary ${activeView === 'form1' ? 'active' : ''}`} onClick={() => setActiveView('form1')}>Form 1</button>
                        <button className={`btn btn-outline-primary ${activeView === 'form2' ? 'active' : ''}`} onClick={() => setActiveView('form2')}>Form 2</button>
                    </div>

                    <div className="table-responsive">
                        <table className="table table-bordered table-striped table-hover" style={{ fontSize: '14px', border: "2px solid black" }}>
                            <thead className="table-dark">
                                <tr>
                                    {activeView === 'women' && (
                                        <>
                                            <th>#</th>
                                            <th>Name</th>
                                            <th>Email</th>
                                            <th>Age</th>
                                            <th>Designation</th>
                                            <th>Applicant Name</th>
                                            <th>contributor role</th>
                                            <th>Action</th>
                                        </>
                                    )}
                                    {activeView === 'form1' && (
                                        <>
                                            <th>#</th>
                                            <th>Name</th>
                                            <th>Email</th>
                                            <th>Phone</th>
                                            <th>Designation</th>
                                            <th>Applicant Name</th>
                                            <th>Experience (Total)</th>
                                            <th>Experience (Same Line)</th>
                                            <th>Contribution</th>
                                            <th>Action</th>
                                        </>
                                    )}
                                    {activeView === 'form2' && (
                                        <>
                                            <th>#</th>
                                            <th>snapshot of the Organisation</th>
                                            <th>Vision</th>
                                            <th>Achievements</th>
                                            <th>Contribution to Exchequer</th>
                                            <th>Tech Adopted</th>
                                            <th>Quality Compliance</th>
                                            <th>Strategic Plan</th>
                                            <th>Action</th>
                                        </>
                                    )}
                                </tr>
                            </thead>
                            <tbody>
                                {activeView === 'women' && women.length > 0 ? (
                                    women.map((item, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{item.women_achiever_form3.name || '-'}</td>
                                            <td>{item.women_achiever_form3.email || '-'}</td>
                                            <td>{item.women_achiever_form3.age || '-'}</td>
                                            <td>{item.women_achiever_form3.designation || '-'}</td>
                                            <td>{item.women_achiever_form3.name1 || '-'}</td>
                                            <td>{item.women_achiever_form3.contributor_role || '-'}</td>
                                            <td><button className="btn btn-sm btn-outline-danger" onClick={() => handleDownloadWomenPdf(item)} >Download PDF</button></td>
                                        </tr>
                                    ))
                                ) : activeView === 'form1' && form1.length > 0 ? (
                                    // Render Form 1 data
                                    form1.map((entry, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{entry.name || '-'}</td>
                                            <td>{entry.email || '-'}</td>
                                            <td>{entry.phone || '-'}</td>
                                            <td>{entry.designation || '-'}</td>
                                            <td>{entry.applicantName || '-'}</td>
                                            <td>{entry.experience_total_years || '-'}</td>
                                            <td>{entry.experience_in_same_line || '-'}</td>
                                            <td>{entry.contribution_checkbox || '-'}</td>
                                            <td><button className="btn btn-sm btn-outline-danger" onClick={() => handleDownloadForm1Pdf(entry)} >Download PDF</button></td>
                                        </tr>
                                    ))
                                ) : activeView === 'form2' && form2.length > 0 ? (
                                    // Render Form 2 data
                                    form2.map((entry, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{entry.snapshot_of_organisation || '-'}</td>
                                            <td>{entry.vision || '-'}</td>
                                            <td>{entry.achievements_of_organisation || '-'}</td>
                                            <td>{entry.contribution_to_exchequer || '-'}</td>
                                            <td>{entry.technology_adopted_indigenous || '-'}</td>
                                            <td>{entry.quality_compliance_iso || '-'}</td>
                                            <td>{entry.strategic_plan_for_future_comment || '-'}</td>
                                            <td><button className="btn btn-sm btn-outline-danger" onClick={() => handleDownloadForm2Pdf(entry)} >Download PDF</button></td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="10" className="text-center">No nominations available</td>
                                    </tr>
                                )}
                            </tbody>


                        </table>
                    </div>

                    {/* Pagination Controls */}
                    <div className="d-flex justify-content-between align-items-center mt-3">
                        <button className="btn btn-outline-primary" onClick={handlePrev} disabled={currentPage === 1}>
                            Previous
                        </button>
                        <span className="fw-bold">Page {currentPage} of {totalPages}</span>
                        <button className="btn btn-outline-primary" onClick={handleNext} disabled={currentPage === totalPages}>
                            Next
                        </button>
                    </div>
                </div>
            )}

            <footer className="bg-light text-center mt-auto py-3">
                <p className="mb-1 small">
                    Powered by
                    <a href="https://emedha.com/" target="_blank" rel="noopener noreferrer" className="text-success ms-1">
                        EMedha Technologies
                    </a>
                </p>
                <a href="https://emedha.com/" target="_blank" rel="noopener noreferrer">
                    <img src={L1} alt="EMedha Logo" className="img-fluid" style={{ maxWidth: '180px' }} />
                </a>
            </footer>
        </div>
    );
};

export default AwardNominationData;
